<!--
 * @Author: your name
 * @Date: 2022-04-27 09:37:46
 * @LastEditTime: 2025-04-03 16:42:51
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jzjy\src\views\ResourceCenter\index.vue
-->

<template>
  <!-- 资源中心页 -->
  <div id="container">
    <div class="bigTap">
      <div class="banben">
        <h4>当前教学版本</h4>
        <p v-if="login_status == 1">{{ kejianversions_title }} <span @click="gokemu">切换</span></p>
        <p v-if="login_status != 1">{{ kejianversions_title }} 
          <!-- <span @click="gokemu">切换</span> -->
          <el-popover
            placement="right-start"
            width="260"
            v-if="login_status == 0"
            v-model="visible">
            <p>请选择版本</p>
            <div class="choseBanben" style="text-align: left; margin: 0;cursor: pointer;">
              <p style="margin-top:10px;margin-left:10px;" :style="{color:(item.id == kejianversions_id?'#1E60EB':'#333')}" v-for="item in banbenList" :key="item.id" @click="qhbb(item)">{{item.title}}</p>
            </div>
            <span slot="reference">切换</span>
          </el-popover>
        </p>
        
      </div>
      <div class="tap">
        <div
          class="tabs"
          v-for="item in menus"
          :key="item.id"
          @click="changeTap(item.id)"
          :class="{ chosebigTap: bigtapvalue == item.id }"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="content">
      <div class="resFl">
        <h2>资源目录</h2>
        <div class="chosedTap" v-if="bigtapvalue == 1 && tbzyChosed.booktitle">
          <span>已选择：</span>
          <div class="chosedtabsLists">
            <div class="chosedtab" v-show="tbzyChosed.booktitle">
              <p>{{ tbzyChosed.booktitle }}</p>
              <i class="el-icon-close" @click="delechosedbook"></i>
            </div>
            <div class="chosedtab" v-show="tbzyChosed.mulu1title">
              <p>{{ tbzyChosed.mulu1title }}</p>
              <i class="el-icon-close" @click="delechosedmulu1"></i>
            </div>
            <div class="chosedtab" v-show="tbzyChosed.mulu2title">
              <p>{{ tbzyChosed.mulu2title }}</p>
              <i class="el-icon-close" @click="delechosedmulu2"></i>
            </div>
            <div class="chosedtab" v-show="tbzyChosed.mulu3title">
              <p>{{ tbzyChosed.mulu3title }}</p>
              <i class="el-icon-close" @click="delechosedmulu3"></i>
            </div>
          </div>
        </div>
        <div class="box">
          <el-collapse v-model="bigTap" accordion @change="changeTap">
            <el-collapse-item name="1">
              <template slot="title">
                <div class="title" :class="{ chose: bigtapvalue == 1 }">
                  <h3>同步资源</h3>
                  <i class="el-icon-arrow-down" v-show="bigtapvalue != 1"></i>
                  <i class="el-icon-arrow-up" v-show="bigtapvalue == 1"></i>
                </div>
              </template>
              <div class="tongbu">
                <div class="bookBox" v-for="(item,index) in booksList" :key="item.id">
                    <div class="bookTitle" :class="{bookchose:tbzyChosed.bookid == item.id}" @click="getmulu1(item.id,0,item.title,index)"><p>{{item.title}}</p><span><i class="el-icon-arrow-down" v-show="tbzyChosed.bookid != item.id"></i><i class="el-icon-arrow-up" v-show="tbzyChosed.bookid == item.id"></i></span></div>
                    <div class="mulu1Box"  v-for="(list1,index1) in mululist1" :key="list1.id" >
                      <div class="mulu1Title" :class="{muluchose:tbzyChosed.mulu1id == list1.id}" @click="getmulu2(list1.id,list1.title,index,index1)"><p>{{list1.title}}</p><span v-if="list1.lists.length >0"><i class="el-icon-arrow-down" v-show="tbzyChosed.mulu1id != list1.id"></i><i class="el-icon-arrow-up" v-show="tbzyChosed.mulu1id == list1.id"></i></span></div>
                      <div class="mulu2Box" v-for="(list2,index2) in mululist2" :key="list2.id" >
                        <div class="mulu2Title" :class="{muluchose:tbzyChosed.mulu2id == list2.id}" @click="getmulu3(list2.id,list2.title,index,index1,index2)"><p>{{list2.title}}</p><span v-if="list2.lists.length >0"><i class="el-icon-arrow-down" v-show="tbzyChosed.mulu2id != list2.id"></i><i class="el-icon-arrow-up" v-show="tbzyChosed.mulu2id == list2.id"></i></span></div>
                        <div class="mulu3Box" v-for="(list3) in mululist3" :key="list3.id" >
                          <div class="mulu3Title" :class="{muluchose:tbzyChosed.mulu3id == list3.id}" @click="getmulu4(list3.id,list3.title,index,index1,index2)">
                            <p>{{list3.title}}</p>
                            <span v-if="list3.lists.length >0"><i class="el-icon-arrow-down"  ></i><i class="el-icon-arrow-up"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <!-- <el-collapse
                  v-model="kejianbooks_id"
                  accordion
                  @change="handleBook"
                >
                  <el-collapse-item
                    :name="item.id"
                    v-for="(item, index) in booksList"
                    :key="item.id"
                  >
                    <template slot="title">
                      <div
                        class="title"
                        @click="choseBook(item.nianji_id, item.title, index)"
                        :class="{ chosetoubuTitle: kejianbooks_id == item.id }"
                      >
                        <h3>{{ item.title }}</h3>
                        <i
                          class="el-icon-arrow-down"
                          v-show="kejianbooks_id != item.id"
                        ></i>
                        <i
                          class="el-icon-arrow-up"
                          v-show="kejianbooks_id == item.id"
                        ></i>
                      </div>
                    </template>
                    <el-tree
                      :data="mululist"
                      :props="defaultProps"
                      :highlight-current="true"
                      :accordion="true"
                      icon-class="el-icon-arrow-down"
                      @node-click="handleNodeClick"
                      node-key="id"
                      :default-expanded-keys="[kejianchapters_id]"
                      empty-text="暂无数据"
                      :expand-on-click-node="true"
                      :auto-expand-parent="true"
                      :default-expand-all="isExpandAll"
                      ref="tree"
                    ></el-tree>
                  </el-collapse-item>
                </el-collapse> -->
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <div class="title" :class="{ chose: bigtapvalue == 2 }">
                  <h3>试卷</h3>
                  <i class="el-icon-arrow-down" v-show="bigtapvalue != 2"></i>
                  <i class="el-icon-arrow-up" v-show="bigtapvalue == 2"></i>
                </div>
              </template>
              <div class="sjflLists">
                <div
                  class="shijuanfl"
                  v-for="item in sjflList"
                  :key="item.id"
                  @click="chosedsjfl(item.id,item.title)"
                  :class="{ chosesjfl: kejiantag_id == item.id }"
                >
                  <h3>{{ item.title }}</h3>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="3">
              <template slot="title">
                <div class="title" :class="{ chose: bigtapvalue == 3 }">
                  <h3>素材库</h3>
                  <i class="el-icon-arrow-down" v-show="bigtapvalue != 3"></i>
                  <i class="el-icon-arrow-up" v-show="bigtapvalue == 3"></i>
                </div>
              </template>
              <div class="scflLists">
                <div
                  class="sucaifl"
                  v-for="item in scflList"
                  :key="item.id"
                  @click="chosedscfl(item.id)"
                  :class="{ chosescfl: kejiantag_id == item.id }"
                >
                  <h3>{{ item.title }}</h3>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="4" v-if="kemu_id ==1 || kemu_id ==3">
              <template slot="title">
                <div class="title" :class="{ chose: bigtapvalue == 4 }">
                  <h3>教学课</h3>
                  <i class="el-icon-arrow-down" v-show="bigtapvalue != 4"></i>
                  <i class="el-icon-arrow-up" v-show="bigtapvalue == 4"></i>
                </div>
              </template>
            </el-collapse-item>
            <el-collapse-item name="5" v-if="dingzhiNj_id != 11 && false">
              <template slot="title">
                <div class="title" :class="{ chose: bigtapvalue == 5 }">
                  <h3>资源包</h3>
                  <i class="el-icon-arrow-down" v-show="bigtapvalue != 5"></i>
                  <i class="el-icon-arrow-up" v-show="bigtapvalue == 5"></i>
                </div>
              </template>
              <div class="ziyuanbaoflLists">
                <div
                  class="ziyuanbaofl"
                  v-for="item in ziyuanbaochaptersLists"
                  :key="item.dy_id"
                  @click="
                    chosedzybfl(
                      item.dy_id,
                      item.kejianbooks_title,
                      item.dy_title
                    )
                  "
                  :class="{ chosescfl: ziyuanbaochapters_id == item.dy_id }"
                >
                  <h3>{{ item.kejianbooks_title }} · {{ item.dy_title }}</h3>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="right">
        <!-- 课件顶部资源包 -->
        <div class="topziyuanbao" v-show="bigtapvalue == 1">
          <div
            class="topzybLists"
            v-for="item in tbzyb"
            :key="item.id"
            @click="gobeikeziyuan(item.id)"
          >
            <div class="pic">
              <img src="../../assets/img/ziyuanbaonew.png" alt="" />
            </div>
            <div class="msg">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="bottom">
                <span class="upTime"
                  >更新于
                  {{ timeStamp2String(item.update_time * 1000, 2) }}</span
                >
                <span class="zynum"
                  >内含<a>{{ item.kejian_nums }}</a
                  >份资源</span
                >
              </div>
            </div>
          </div>
        </div>
        <!-- 课件分类，右侧横向tap -->
        <div
          class="kejianTaps"
          v-show="bigtapvalue == 1 && kejianflList.length != 0"
        >
          <div class="flname">
            <span style="marginleft: 20px">分类：</span>
            <span
              :class="{ fenlei_color: kejianfl_id == item.id }"
              v-for="item in kejianflList"
              :key="item.id"
              @click="choseKejianfl(item.id, item.systypes_id, item.title)"
              >{{ item.title }}</span
            >
          </div>
        </div>
        <!-- 试卷顶部分类 -->
        <div class="topshijuanfl" v-show="bigtapvalue == 2">
          <div class="topfl">
            <div class="fltitle">类型：</div>
            <div class="fllists">
              <span
                class="flall"
                :class="{ chosedsjfl: kejiantag_id == '' }"
                @click="choseall('fl')"
                >全部</span
              >
              <span
                v-for="item in sjflList"
                :key="item.id"
                @click="chosedsjfl(item.id,item.title)"
                :class="{ chosedsjfl: kejiantag_id == item.id }"
                >{{ item.title }}</span
              >
            </div>
          </div>
          <div class="topfl">
            <div class="fltitle">年级：</div>
            <div class="fllists">
              <span
                class="flall"
                :class="{ chosedsjfl: sjNjId == '' }"
                @click="choseall('nianji')"
                >全部</span
              >
              <span
                v-for="item in nianjilists"
                :key="item.id"
                @click="chosedsjnj(item.id,item.title)"
                :class="{ chosedsjfl: sjNjId == item.id }"
                >{{ item.title }}</span
              >
            </div>
          </div>
          <div class="topfl">
            <div class="fltitle">地区：</div>
            <div class="fllists">
              <!-- <span
                class="flall"
                :class="{ chosedsjfl: sjDqId == '' }"
                @click="choseall('diqu')"
                >全部</span
              > -->
              <span
                v-for="item in diquLists.slice(0, sjdqNum)"
                :key="item.id"
                @click="chosedsjdq(item.id,item.title)"
                :class="{ chosedsjfl: sjDqId == item.id }"
                >{{ item.title }}</span
              >
              <span @click="getalldq" v-show="getalldqshow">展开更多></span>
              <span @click="getsomedq" v-show="!getalldqshow">收起></span>
            </div>
          </div>
          <div class="topfl">
            <div class="fltitle">年份：</div>
            <div class="fllists">
              <span
                class="flall"
                :class="{ chosedsjfl: sjNfId == '' }"
                @click="choseall('nianfen')"
                >全部</span
              >
              <span
                v-for="item in nianfenLists.slice(0, sjnfNum)"
                :key="item.id"
                @click="chosedsjnf(item.id,item.title)"
                :class="{ chosedsjfl: sjNfId == item.id }"
                >{{ item.title }}</span
              >
              <span @click="getallnf" v-show="getallnfshow">展开更多></span>
              <span @click="getsomenf" v-show="!getallnfshow">收起></span>
            </div>
          </div>
        </div>
        <!-- 素材库的分类 -->
        <div class="sucaiTaps" v-if="bigtapvalue == 3">
          <div class="topfl">
            <div class="fltitle">分类：</div>
            <div class="fllists">
              <span
                :class="{
                  chosedfl: kejiantag_id == 0,
                }"
                @click="chosedscfl(0)"
                >全部</span
              >
              <span
                :class="{
                  chosedfl: kejiantag_id == item.id,
                }"
                @click="chosedscfl(item.id,item.title)"
                v-for="item in scflList"
                :key="item.id"
                >{{ item.title }}</span
              >
            </div>
          </div>
          <div class="topfl">
            <div class="fltitle">时间：</div>
            <div class="fllists">
              <span
                :class="{
                  chosedfl: scTimeId == item.id,
                }"
                @click="chosesucaiTagfl(item.id,item.title)"
                v-for="item in scTagList"
                :key="item.id"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
        <!-- 教研课和教学课的标签 -->
        <div class="jiaoxueclass" v-if="bigtapvalue == 4">
          <div class="taps">
            <span style="marginleft: 20px">分类：</span>
            <span
              :class="{
                chosedfl: classof == item.id,
              }"
              @click="chosejyjxTagfl(item.id, item.title)"
              v-for="item in jyjxTagList"
              :key="item.id"
              >{{ item.title }}</span
            >
          </div>
        </div>
        <!-- 资源包的分类 -->
        <div
          class="sucaiTaps"
          v-if="bigtapvalue == 5 && ziyuanbaochaptersLists.length != 0"
        >
          <div class="topfl">
            <div class="fltitle">分类：</div>
            <div class="fllists">
              <span
                :class="{
                  chosedfl: ziyuanbaochapters_id == item.dy_id,
                }"
                @click="
                  chosedzybfl(item.dy_id, item.kejianbooks_title, item.dy_title)
                "
                v-for="item in ziyuanbaochaptersLists"
                :key="item.dy_id"
                >{{ item.kejianbooks_title }} · {{ item.dy_title }}</span
              >
            </div>
          </div>
        </div>
        <!-- 课件列表  正常课件模块-->
        <div class="kejianlist" v-if="bigtapvalue != 4 && bigtapvalue != 5">
          <div
            class="kejianBox"
            v-for="item in kejianLists"
            :key="item.id"
            v-show="kejianLists != [] && kejianfl_id < 10000"
            
          >
            <div class="kejianfile"  @click="goresDetails(item.id, item.suffix)">
              <img
                src="../../assets/img/ziyuan.png"
                v-if="item.lx == 2"
                style="height: 74px"
              />
              <img
                src="../../assets/img/resFile (1).png"
                alt="file_url"
                v-if="
                  item.suffix == 'ppt' ||
                  item.suffix == 'pptx' ||
                  item.suffix == 'ppsx' ||
                  item.suffix == 'pps'
                "
              />
              <img
                src="../../assets/img/resFile (2).png"
                alt="file_url"
                v-if="item.suffix == 'mp4' || item.suffix == 'rm'"
              />
              <img
                src="../../assets/img/resFile (3).png"
                alt="file_url"
                v-if="item.suffix == 'xls' || item.suffix == 'xlsx'"
              />
              <img
                src="../../assets/img/resFile (4).png"
                alt="file_url"
                v-if="item.suffix == 'zip' || item.suffix == 'rar'"
              />
              <img
                src="../../assets/img/resFile (5).png"
                alt="file_url"
                v-if="item.suffix == 'm4a' || item.suffix == 'mp3'"
              />
              <img
                src="../../assets/img/resFile (6).png"
                alt="file_url"
                v-if="item.suffix == 'doc' || item.suffix == 'docx'"
              />
              <img
                src="../../assets/img/resFile (7).png"
                alt="file_url"
                v-if="item.suffix == 'pdf'"
              />
              <img
                src="../../assets/img/resFile (8).png"
                alt="file_url"
                v-if="item.suffix == 'png' || item.suffix == 'jpg'"
              />
            </div>
            <div class="msg" @click="goresDetails(item.id, item.suffix)">
              <div class="title">
                <!-- <img src="../../assets/img/newBiaoqian.png" v-show="item.is_new == 1"> -->
                <img src="../../assets/img/ffzyb/vip.png" v-show="item.is_sf == 1" >
                <span v-if="item.is_tj == 1 && item.is_sf != 1">精选</span>{{ item.title }}
              </div>
              <!-- <p v-if="!item.lx || item.lx == 1" style="height: 80px">
              {{ item.intro == "" ? "暂无" : item.intro }}
              </p> -->
              <p v-html="item.sub_info" v-if="item.lx == 2" ></p>
              <span v-if="item.lx == 2">......</span>
              <div class="bottom">
                <!-- <span class="upTime" v-if="item.from_int != 10">
                  更新于{{ timeStamp2String(item.update_time * 1000, 2) }}
                </span>
                <span
                  class="upTime"
                  v-if="item.from_int == 10"
                  style="color: #ff9b04"
                >
                  精选
                </span> -->
                <div class="gzs" v-if="item.starteacherstudio_id">
                    <img src="../../assets/img/5.0/tecStudio (3).png" alt="">
                    <div class="gzsTitle">{{item.starteacherstudio_title}}</div>
                </div>
                <span class="rate" v-if="item.tjzs != 0 && !item.starteacherstudio_id"
                  ><span style="margin-right: 5px">精选指数</span>
                  <el-rate disabled v-model="item.tjzs"></el-rate
                ></span>
                <span class="rate" v-if="item.tjzs == 0"
                  ><span style="margin-right: 5px">暂无评分</span>
                </span>
                <span class="seeNum" v-if="!item.lx || item.lx == 1"
                  ><i class="el-icon-view"></i>{{ item.viewCount }}</span
                >
                <span class="seeNum" v-if="item.lx == 2"
                  ><i class="el-icon-view"></i>{{ item.view_nums }}</span
                >
                <span class="upTime" v-if="getBefore2Year(item.update_time)">
                  {{ timeStamp2String(item.update_time * 1000, 2) }}
                </span>
              </div>
            </div>
            <div class="fenge"></div>
            <div class="kejianright">
              <div class="downLoad" @click="goresDetails(item.id, item.suffix)">查看全部</div>
              <div class="soucang" @click="sckj(item.id)" v-if="item.sc_status == 0"><img src="../../assets/img/tbsc1.png">加入收藏</div>
              <div class="soucang" @click="qxsc(item.id)" v-if="item.sc_status == 1" style="color:#1E60EB"><img src="../../assets/img/5.0/ziyuan (3).png">已收藏</div>
              <div class="money" v-if="item.is_sf == 1 && item.is_pay == 0"><p>￥{{item.price}}</p><span>收费</span></div>
              <div class="money" v-if="item.is_sf == 1 && item.is_pay == 1"><img src="../../assets/img/5.0/ygm.png"><h6>已购买</h6></div>
              <!-- <div class="money" v-if="item.is_sf == 0">免费</div>
              <div class="money" v-if="item.is_sf == 1 && item.gm_status == 0"><img src="../../assets/img/money.png">付费资源</div>
              <div class="money" v-if="item.is_sf == 1 && item.gm_status == 1"><img src="../../assets/img/money.png">已解锁</div> -->
            </div>
          </div>
        </div>
        <!-- 课件列表 教研课和教学课模块-->
        <div class="kejianlist" v-if="kejianLists.length != 0">
          <div class="kejianBox" v-show="kejianLists != [] && bigtapvalue == 4">
            <div class="jiaoyan">
              <div
                class="box jiaoyanbox"
                v-for="item in kejianLists"
                :key="item.jyjxkinfo_id"
                @click="goJiaoyanclass(item.jyjxk_id)"
              >
                <img :src="item.fm_file_url" alt="" />
                <div class="activename">
                  {{ item.title }}
                </div>
                <p>主讲人：{{ item.teachers_title }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 课件列表 资源包模块-->
        <div
          class="kejianlist"
          v-if="kejianLists.length != 0 && bigtapvalue == 5"
        >
          <div
            class="ziyuanbaoLists"
            v-for="item in kejianLists"
            :key="item.id"
            @click="gobeikeziyuan(item.id)"
            v-show="kejianLists != [] && bigtapvalue == 5"
          >
            <div class="pic">
              <img src="../../assets/img/ziyuanbaonew.png" />
            </div>
            <div class="msg">
              <div class="kejiantitle">
                <p>
                  {{ item.title }}
                </p>
              </div>
              <div class="ziyuanbaodetails">
                <span>内含：</span>
                <span
                  class="leixing"
                  v-for="list in item.kejianfl_arr"
                  :key="list.kejianfl_id"
                  >{{ list.kejianfl_title }}</span
                >
                <span
                  >共<a>{{ item.kejian_nums }}</a
                  >份资源</span
                >
              </div>
              <div class="bottom">
                <span class="upTime"
                  >更新于{{
                    timeStamp2String(item.update_time * 1000, 2)
                  }}</span
                >
                <span class="seeNum"
                  ><i class="el-icon-view"></i>{{ item.view_nums }}</span
                >
              </div>
            </div>
            <div class="downLoad">
             <p>查看全部</p> 
              <!-- <div class="money" v-if="item.is_sf == 0">免费</div>
              <div class="money" v-if="item.is_sf == 1 && item.gm_status == 0"><img src="../../assets/img/money.png">付费资源</div>
              <div class="money" v-if="item.is_sf == 1 && item.gm_status == 1"><img src="../../assets/img/money.png">已解锁</div> -->
            </div>
            
          </div>
        </div>
        <!-- 空图是否展示 -->
        <div class="nothing" v-show="nothingShow">
          <!-- kejianLists.length == 0 -->
          <p>抱歉，没有为您搜索到相关内容，可以去看看其他资源哦！</p>
          <img src="../../assets/img/nothing.png" alt="" />
        </div>

        <!-- 分页部分 -->
        <div class="page1" v-if="kejianLists.length > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            background
            :page-sizes="[6, 10,20]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="counts"
          >
          </el-pagination>
        </div>
      </div>
    </div>
     <!-- 更新提醒弹窗 -->
    <gxtxTc
      v-if="gxtxShow"
      @gxtcClose="gxtcClose"
      :zykf_file_url="gxkf_file_url"
    >
    </gxtxTc>
    <!-- 首次进入网站未有年级科目版本弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
      width="800px"
    >
      <div class="kmchose">
        <p>1.请选择您所在的年级：</p>
        <div class="tab1 taps">
          <div
            class="classRadio"
            v-for="item in nianjiList"
            :key="item.id"
            @click="radio3 = item.id"
          >
            <div class="tips1 tips" v-if="radio3 != item.id"><span></span></div>
            <div class="tips2 tips" v-if="radio3 == item.id"><span></span></div>
            <p>{{ item.title }}</p>
          </div>
        </div>
        <p>2.请选择您所教的学科：</p>
        <div class="tab1 taps">
          <div
            class="classRadio"
            v-for="item in classList"
            :key="item.id"
            @click="changeKemu(item.id)"
          >
            <div class="tips1 tips" v-if="radio1 != item.id"><span></span></div>
            <div class="tips2 tips" v-if="radio1 == item.id"><span></span></div>
            <p>{{ item.title }}</p>
          </div>
        </div>
        <p>3.请选择您所教学科的教学版本：</p>
        <div class="tab2 taps">
          <div
            class="classRadio"
            v-for="item in banbenList"
            :key="item.id"
            @click="radio2 = item.id"
          >
            <div class="tips1 tips" v-if="radio2 != item.id"><span></span></div>
            <div class="tips2 tips" v-if="radio2 == item.id"><span></span></div>
            <p>{{ item.title }}</p>
          </div>
        </div>
        <div class="submitSet" @click="submit">
          <span>提交</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { timeStamp2String } from "../../utils/time";
import gxtxTc from "../../components/gxtxTc/gxtx.vue"
import {
  list_kejianbao,
  kejianfl,
  list_kejiantag,
  nowkemu,
  userinfo,
  bookslists,
  chapterslists,
  list_kejian,
  chaptersinfo,
  jyjxkinfolists,
  tjlists,
  zyzxinfo,
  zyzxgs,
  zyzxfk,
  list_jyjxk,
  chapterskejian,
  list_systypes,
  nianjilists,
  tjlists_dy,
  create_accountzysc,
   getgoodsweekpopup,
  closepopup,
  islogin,
  kemulists,
  versionslists,
} from "../../api/http";
export default {
  inject: ["reload"], //刷新页面
  name: "resourceCenter",
  components:{
    gxtxTc
  },
  metaInfo () {
    return {
      title: '高中教材同步资源下载_教学资源_课件下载_试卷下载-精准教研教学平台',
       meta: [{ 
        name: 'Keywords',
        content: '高中试题试卷,同步课件PPT,同步学案,教学设计,教学素材,备考资源'
      }, {
        name: 'description',
        content: '精准教研教学平台为您提供高中同步备课教学资源，包括高中试题试卷、同步课件PPT、同步学案、教学设计、教学素材、单元检测卷、复习备考资源等。资源均由专家、名师联合打造，经教研老师严格审核，质量保证。'
      }],
    }
  },
  data() {
    return {
      Keywords:'',
      description:'',
      isExpandAll: false,
      gundongTop: 0, //滚动条高度
      kejianbooks_title: "", //当前学习的书本名
      kejianchapters_title: "", //当前学习的目录名
      timeLine: {}, //关键事件节点对象
      //用于顶部日期时间尺子
      monthNow: "", //当前几月
      currentMonthCount: 0, //本月天数
      nextMonthCount: 0, //下个月天数
      fenlei_radio: 1, //试卷分类值
      scrollY: 0, //资源库距离顶部位置
      start_date: "", //当前计划开始时间
      end_date: "", //当前计划结束时间
      stime: "", //开始的那一天
      etime: "", //结束的那天
      scolorTime: "", //时间尺绿色开始日期
      ecolorTime: "", //时间尺绿色开始日期
      smonth: "", //计划开始的月份
      emonth: "", //计划结束的月份
      kejianbao_nums: "", //资源包数量
      kejian_nums: "", //资源数量

      timeStamp2String, //时间戳转时间的函数

      // 资源定制部分
      dingzhishow: true, //定制部分是否展示
      //资源包信息介绍
      dingzhiNj_id: "", //用户个人当前的年级id
      contents: "", //整理来源介绍
      contents1: "", //教师教研介绍//一轮复习介绍
      contents2: "", //教师教学介绍//二轮复习介绍
      contents3: "", //学生学习介绍//三轮复习介绍 //暂无
      contents4: "", //真题试卷介绍
      //资源包下的教研课的视频列表

      dingzhiRadio: "1", //定制切换栏按钮默认值

      //高一高二
      gyezyLists: [], //教师教研课件包资
      gyespLists: [], //教师教学课件包数量
      gyezy1: 0, //高一二部分教师教研资源数量
      gyezy2: 0, //高一二部分教师教学资源数量
      gyezy3: 0, //高一二部分学生学习资源数量

      gyesp1: 0, //高一二部分教师教研视频数量
      gyesp2: 0, //高一二部分教师教学视频数量
      gyesp3: 0, //高一二部分学生学习视频数量

      radio: "1", //调查有用没用
      beikeFlag: false, //资源包hover样式切换
      n: 0, //当前鼠标移动到的资源包的id

      //高三部分
      gszyLists: [], //高三部分的最新资源列表
      gszxLists: [], //高三部分的专项列表
      gsspLists: [], //高三部分的视频列表
      gszy1: 0, //一轮复习课件包数量
      gszy2: 0, //二轮复习课件包数量
      gszy3: 0, //试卷课件包数量
      gszx1: 0, //一轮复习专项数量
      gszx2: 0, //二轮复习专项数量
      gszx3: 0, //试卷专项数量
      gssp1: 0, //一轮复习视频数量
      gssp2: 0, //二轮复习视频数量
      gssp3: 0, //试卷视频数量
      gs: 0, //高三部分鼠标移动到的资源包id
      gsyilunCh: 0, //高三部分鼠标移动到的资源包id
      gsyilunYf: 0, //高三部分鼠标移动到的资源包id
      gserlunL: 0, //高三部分鼠标移动到的资源包id
      gserlunR: 0, //高三部分鼠标移动到的资源包id
      nothingShow: false, //空图是否展示

      //资源库
      input: "", //资源库搜索框双向绑定内容
      fenleiRadio: 1, //当前选中的分类值，用于切换课件分类tap
      currentPage: 1, //分页默认选中页

      //资源库数据的展示
      booksList: [], //左侧书本列表
      mululist1: [], //根据书本id获取的一级目录列表
      mululist2: [], //根据一级目录id获取的二级目录列表
      mululist3: [], //根据二级目录id获取的三级目录列表
      defaultProps: {
        //书本目录对应后台数据的默认字段
        children: "lists",
        label: "title",
      },
      // bookNianji_id: 0, //获取图书列表第一本书的所属年级id，用于右侧分类
      kejianflList: [], //课件分类列表
      kejianfltaglist: [], //课件分类下的分类标签
      kejiantag_id: "", //课件分类标签id
      jyjxTagList: [
        { id: "all", title: "全部" },
        { id: "time", title: "最新课程" },
        { id: "xg", title: "相关课程" },
        { id: "play", title: "最多播放" },
      ], //教研课和教学课的标签
      //由下面参数决定资源页课件展示内容，点击切换相关选项可更改展示内容，初始默认内容由个人信息和当前目录版本信息里获取。
      kejianbooks_id: 0, //书本id
      kemu_id: 0, //当前科目id
      nianji_id: 0, //书本年级id
      kejianfl_id: 0, //课件分类id
      kejiantagShow: false, //课件分类下的标签是否展示
      kejianversions_id: 0, //当前版本id
      kejianchapters_id: 0, //目录id
      systypes_id: 1, //系统大分类标签(1.课件.2.试卷.3.素材.4.专项) 获取标签分类使用
      status: "", //状态
      page: 1, //页码
      page_size: 6, //分页大小
      kejianLists: [], //课件资源列表数据
      counts: 0, //当前请求到的课件总条数用于分页显示总数
      fk_status: "", //是否反馈过
      yy_status: "1", //是否有用
      fkshow: true, //提交是否有用的显示隐藏


      // 4.2迭代使用
      kejianversions_title: "", //当前教学版本名
      menus: [
        { id: "1", title: "同步资源" },
        { id: "2", title: "试卷" },
        { id: "3", title: "素材库" },
        // { id: "4", title: "教学课" },
      ], //模块大分类
      bigTap: "1", //大菜单栏选项值
      bigtapvalue: "1", //大分类选定值
      bigTitle: "同步资源", //大菜单栏选项mingcheng
      chosedbook: "", //资源目录展示的选择的图书
      chosedmulu1: "", //资源目录展示的选择的第一个目录
      chosedmulu2: "", //资源目录展示的选择的第二个目录
      chosedmulu3: "", //资源目录展示的选择的第三个目录
      mulutree: [0, 1, 2, 3], //保留的单元id
      mulu1: {}, //同步资源左侧资源目录点击删除使用node
      mulu2: {}, //同步资源左侧资源目录点击删除使用node
      mulu3: {}, //同步资源左侧资源目录点击删除使用node

      tbzyb: [], //同步资源课件顶部资源包展示列表


      sjflList: [], //试卷分类列表
      sjdqNum: 8, //试卷地区分类展示数量
      sjnfNum: 7, //试卷年份分类展示数量
      getalldqshow: true, //试卷地区分类展开全部显示隐藏
      getallnfshow: true, //试卷年份分类展开全部显示隐藏
      nianjilists: [], //年级列表
      diquLists: [], //地区列表
      nianfenLists: [], //年份列表
      sjNfId: "", //试卷年份id
      sjDqId: "", //试卷地区id

      sucaitap: "", //素材大分类id
      scflList: [], //素材分类列表
      scTagList: [
        { id: 0, title: "全部" },
        { id: 1, title: "最近一天" },
        { id: 7, title: "最近一周" },
        { id: 30, title: "最近一月" },
        { id: 365, title: "今年发布" },
      ], //素材标签列表
      scTimeId: 0, //素材近期
      ziyuanbaochapters_id: "", //资源包目录id
      ziyuanbaochaptersLists: [], //资源包目录列表

      classof: "all", //教学课选择分类

      QueryMsg: {}, //query参数
      //各详情页面包屑参数以及回跳参数
      sjFlTitle: "", //试卷类型名
      sjFlId: 0, //试卷类型id
      sjNjTitle: "全部", //试卷选中年级名
      sjNjId: '', //试卷选中年级id
      sjDqTitle: "全国", //试卷选中地区名
      sjDqId: '', //试卷选中地区id
      sjNfTitle: "全部", //试卷选中年份名
      sjNfId: "", //试卷选中年份id
      scFlTitle: "全部", //素材类型名
      scFlId: "", //素材类型id
      scTimeTitle: "全部", //素材时间名
      scTimeId: "", //素材时间端
      jxkFlTitle: "全部", //教学课分类名
      jxkFlId: "", //教学课分类id
      zybFlTitle: "", //资源包分类单元名
      bookHeight:'48',//书本标题高度
      muluHeight:'44',//目录标题高度
      tbzyChosed:{
        bookindex:'',
        bookid:'',
        booktitle:'',

        mulu1index:'',
        mulu1:'',
        mulu1id:'',
        mulu1title:'',

        mulu2:'',
        mulu2id:'',
        mulu2title:'',

        mulu3:'',
        mulu3id:'',
        mulu3title:'',

        pid:'',
      },//同步资源下书本和目录的选中情况
      gxtxShow:false,//更新提醒弹窗展示
      gxkf_file_url:'',//售后客服

      booknjid:'',//选中的书本年级id

        //首次进入弹窗相关内容
      dialogTableVisible: false, //提交信息弹窗
      nianjiList: [], //可选年级列表
      classList: [], //学科列表
      banbenList: [], //版本列表
      radio3: "9", //年级值
      radio1: "1", //学科值
      radio2: "", //版本值

      visible:false,
      login_status:0,
    };
  },
  created() {
    $(document).ready(function () {
      $(window).scrollTop(0);
    });
    //获取资源中心数据 获取进入页面上半部分的资源包和当前计划的高一高二相关数据
    // this.getzyall();
    //定义query数据
    this.QueryMsg = this.$route.query;
    console.log(this.QueryMsg, "query参数");

    islogin({
      md5key: localStorage.getItem("md5key"),
    }).then(res=>{
      this.login_status = res.retRes.login_status;
      if(this.login_status == 1){
        //判断过期
        userinfo({
          md5key: localStorage.getItem("md5key"),
        }).then((res) => {
            //获取当前科目和版本
            nowkemu({
              md5key: localStorage.getItem("md5key"),
            }).then((res) => {
              console.log(res, "当前科目和版本");
              const data = res.retRes;
              this.status = data.is_now; //是否当前

              //用户个人信息里的年级id
              this.dingzhiNj_id = data.nianji_id;
              if(data.kemu_id == 1 || data.kemu_id == 3){
                this.menus = [
                  { id: "1", title: "同步资源" },
                  { id: "2", title: "试卷" },
                  { id: "3", title: "素材库" },
                  { id: "4", title: "教学课" },
                ]
              }else{
                this.menus = [
                  { id: "1", title: "同步资源" },
                  { id: "2", title: "试卷" },
                  { id: "3", title: "素材库" },
                  // { id: "4", title: "教学课" },
                ]
              }

              //如果当前的版本或科目为0，跳转到选择版本页
              if (data.kejianversions_id == 0 || data.kemu_id == 0) {
                this.$alert("您还未选择学科或版本，请先前往选择", "温馨提示", {
                  confirmButtonText: "确定",
                  callback: () => {
                    this.$router.push({
                      name: "ChangeClass",
                    });
                  },
                });
                //如果当前的计划开始时间结束时间不存在或科目为0，跳转到设置教学计划
              } else if (data.have_plan == 0) {
                this.$alert("您目前还没有教学计划，请先前往设置", "温馨提示", {
                  confirmButtonText: "确定",
                  callback: () => {
                    this.$router.push({
                      name: "MyTeachPlan",
                    });
                  },
                });
              } else {
                //从当前科目和版本接口中获取的数据
                this.kemu_id = data.kemu_id; //当前科目id
                this.kejianversions_title = data.kejianversions_title; //当前版本名
                this.kejianversions_id = data.kejianversions_id; //当前版本id
                
                //获取书本列表
                bookslists({
                  md5key: localStorage.getItem("md5key"),
                  kejianversions_id: this.kejianversions_id,
                  kemu_id: this.kemu_id,
                }).then((res) => {
                  this.booksList = res.retRes;
                  //如果是首页或精选资源页的查看更多跳转过来
                  if (this.QueryMsg.fliter) {
                    document.documentElement.scrollTop = 0
                    if (this.QueryMsg.fliter == "zy") {
                      this.kejianbooks_id = this.tbzyChosed.bookid = ''
                      this.kejianbooks_title = this.tbzyChosed.booktitle = ''
                      this.kejianchapters_id = this.tbzyChosed.mulu1id = "";
                      this.kejianchapters_title = this.tbzyChosed.mulu1title = "";
                      this.getkejianfl(); //获取课件分类
                    } else if (this.QueryMsg.fliter == "sj") {
                      this.bigtapvalue = 2;
                      this.bigTap = "2";
                      this.systypes_id = 2;
                      this.nianji_id = "";
                      this.getkejianfl(); //获取课件分类
                    } else if (this.QueryMsg.fliter == "sc") {
                      this.systypes_id = 3;
                      this.bigTap = "3";
                      this.bigtapvalue = 3;
                      this.getkejianfl(); //获取课件分类
                    }
                  }else if(this.QueryMsg.from && this.QueryMsg.bigTap){
                    //各详情页面包屑回跳过来的
                    this.gundongTop = this.QueryMsg.Top?this.QueryMsg.Top:0;
                    document.documentElement.scrollTop = this.gundongTop ? this.gundongTop : 0;//跳转各详情页后通过面包屑回跳保留跳转前的页面滚动高度
                    this.bigTap = this.QueryMsg.bigTap;
                    this.bigtapvalue = this.QueryMsg.bigTap;
                    const mb_bigtap = this.QueryMsg.bigTap;
                    this.currentPage = JSON.parse(this.QueryMsg.page);
                    this.page = this.QueryMsg.page;
                    this.page_size = this.QueryMsg.pageSize;
                    if (mb_bigtap == 1) {
                      this.systypes_id =this.QueryMsg.feleiDid && this.QueryMsg.feleiDid == 1000?4: 1;
                      this.bigtapvalue = 1;
                      this.bigTitle = '同步资源'
                      this.tbzyChosed.bookid = this.kejianbooks_id = this.QueryMsg.bookId?this.QueryMsg.bookId:''; //当前书本id
                      this.tbzyChosed.booktitle = this.kejianbooks_title = this.QueryMsg.bookTitle?this.QueryMsg.bookTitle:''; //当前学习的书本名
                      this.kejianchapters_id = this.QueryMsg.mulu3id?this.QueryMsg.mulu3id:this.QueryMsg.mulu2id?this.QueryMsg.mulu2id:this.QueryMsg.mulu1id; //当前学习的目录id
                      this.tbzyChosed.mulu1id = this.QueryMsg.mulu1id?this.QueryMsg.mulu1id:'';//同步资源分类下的目录id
                      this.tbzyChosed.mulu1title = this.QueryMsg.mulu1title?this.QueryMsg.mulu1title:'';//同步资源分类下的目录名称
                      this.tbzyChosed.mulu2id = this.QueryMsg.mulu2id?this.QueryMsg.mulu2id:'';//同步资源分类下的目录id
                      this.tbzyChosed.mulu2title = this.QueryMsg.mulu2title?this.QueryMsg.mulu2title:'';//同步资源分类下的目录名称
                      this.tbzyChosed.mulu3id = this.QueryMsg.mulu3id?this.QueryMsg.mulu3id:'';//同步资源分类下的目录id
                      this.tbzyChosed.mulu3title = this.QueryMsg.mulu3title?this.QueryMsg.mulu3title:'';//同步资源分类下的目录名称
                      this.fenleiTitle = this.QueryMsg.fenleiTitle?this.QueryMsg.fenleiTitle:'';//同步资源分类名
                      this.kejianfl_id = this.QueryMsg.feleiDid?this.QueryMsg.feleiDid:'';//同步资源分类id
                      this.getkejianfl(); //获取课件分类
                      setTimeout(()=>{
                        this.getallMuluByPm(); //详情页回调或url地址复制的书本和目录id来获取选中的书本目录树
                      },200)
                    } else if (mb_bigtap == 2) {
                      this.bigTitle = '试卷'
                      this.systypes_id = 2;
                      this.bigtapvalue = 2;
                      this.nianji_id = "";
                      this.kejianfl_id = 0;

                      this.sjFlTitle = this.QueryMsg.sjFlTitle?this.QueryMsg.sjFlTitle:'全部', //试卷类型名
                      this.kejiantag_id = this.QueryMsg.sjFlId?this.QueryMsg.sjFlId:'', //试卷类型id
                      this.sjNjTitle = this.QueryMsg.sjNjTitle?this.QueryMsg.sjNjTitle:'全部', //试卷选中年级名
                      this.sjNjId = this.QueryMsg.sjNjId?this.QueryMsg.sjNjId:'', //试卷选中年级id
                      this.sjDqTitle = this.QueryMsg.sjDqTitle?this.QueryMsg.sjDqTitle:'', //试卷选中地区名
                      this.sjDqId = this.QueryMsg.sjDqId?this.QueryMsg.sjDqId:'', //试卷选中地区id
                      this.sjNfTitle = this.QueryMsg.sjNfTitle?this.QueryMsg.sjNfTitle:'全部', //试卷选中年份名
                      this.sjNfId = this.QueryMsg.sjNfId?this.QueryMsg.sjNfId:'', //试卷选中年份id
                      this.getkejianlists();
                    } else if (mb_bigtap == 3) {
                      this.bigTitle = '素材'
                      this.systypes_id = 3;
                      this.bigtapvalue = 3;
                      this.kejianfl_id = 0;
                      this.scFlTitle = this.QueryMsg.scFlTitle?this.QueryMsg.scFlTitle:'全部', //素材类型名
                      this.kejiantag_id = this.scFlId = this.QueryMsg.scFlId?this.QueryMsg.scFlId:'', //素材类型id
                      this.scTimeTitle = this.QueryMsg.scTimeTitle?this.QueryMsg.scTimeTitle:'全部', //素材时间名
                      this.scTimeId = this.QueryMsg.scTimeId?this.QueryMsg.scTimeId:'', //素材时间端
                      this.getkejianlists();
                    } else if (mb_bigtap == 4) {
                      this.bigTitle = '教学课'
                      this.bigtapvalue = 4;
                      this.kejianfl_id = 0;
                      this.jxkFlTitle = this.QueryMsg.jxkFlTitle?this.QueryMsg.jxkFlTitle:'全部', //教学课分类名
                      this.classof = this.QueryMsg.jxkFlId?this.QueryMsg.jxkFlId:'all', //教学课分类id
                      this.getjxk();
                    } else if (mb_bigtap == 5) {
                      this.bigTitle = '资源包'
                      this.bigtapvalue = 5;
                      this.kejianfl_id = 0;
                      this.zybFlTitle = this.QueryMsg.zybFlTitle;
                      this.ziyuanbaochapters_id = this.QueryMsg.zybFlId;
                      this.getkejianbaolists();
                    }
                  }else{
                  this.tbzyChosed.bookid = this.kejianbooks_id = data.kejianbooks_id
                  this.tbzyChosed.booktitle = this.kejianbooks_title = data.kejianbooks_title
                  this.tbzyChosed.mulu1id = this.kejianchapters_id = data.kejianchapters_id
                  this.tbzyChosed.mulu1title = this.kejianchapters_title = data.kejianchapters_title
                  this.kejianfl_id = 0;
                  this.fenleiTitle = '全部';
                  this.getkejianfl(); //获取课件分类
                    setTimeout(()=>{
                      this.getallMulu(); //无任何参数跳转的情况下根据当前科目版本的书本和目录id来获取选中的书本目录树
                    },300)
                  }
                  this.getshijaunfl(); //获取试卷分类
                  this.getsucaifl(); //获取试卷分类
                  this.getdqnf(); //获取试卷分类的年份地区
                });
              }
            });
        });
      }else{
        this.kemu_id = localStorage.getItem('tckm')?localStorage.getItem('tckm'):'';
        this.nianji_id = localStorage.getItem('tckm')?localStorage.getItem('tcnj'):'';
        this.kejianversions_id = localStorage.getItem('tckm')?localStorage.getItem('tcbb'):'';
        versionslists({
          md5key: localStorage.getItem("md5key"),
          kemu_id: this.kemu_id,
        }).then((res) => {
          const data = res.retRes;
          this.banbenList = data;
          data.forEach(item=>{
            if(item.id == this.kejianversions_id){
              this.kejianversions_title = item.title
            }
          })
        });
        
        this.menus = [
          { id: "1", title: "同步资源" },
          { id: "2", title: "试卷" },
          { id: "3", title: "素材库" },
          { id: "4", title: "教学课" },
        ]
        //获取书本列表
        bookslists({
          md5key: localStorage.getItem("md5key"),
          kejianversions_id: this.kejianversions_id,
          kemu_id: this.kemu_id,
        }).then((res) => {
          this.booksList = res.retRes;
          //如果是首页或精选资源页的查看更多跳转过来
          if (this.QueryMsg.fliter) {
            document.documentElement.scrollTop = 0
            if (this.QueryMsg.fliter == "zy") {
              this.kejianbooks_id = this.tbzyChosed.bookid = ''
              this.kejianbooks_title = this.tbzyChosed.booktitle = ''
              this.kejianchapters_id = this.tbzyChosed.mulu1id = "";
              this.kejianchapters_title = this.tbzyChosed.mulu1title = "";
              this.getkejianfl(); //获取课件分类
            } else if (this.QueryMsg.fliter == "sj") {
              this.bigtapvalue = 2;
              this.bigTap = "2";
              this.systypes_id = 2;
              this.nianji_id = "";
              this.getkejianfl(); //获取课件分类
            } else if (this.QueryMsg.fliter == "sc") {
              this.systypes_id = 3;
              this.bigTap = "3";
              this.bigtapvalue = 3;
              this.getkejianfl(); //获取课件分类
            }
          }else if(this.QueryMsg.from && this.QueryMsg.bigTap){
            //各详情页面包屑回跳过来的
            this.gundongTop = this.QueryMsg.Top?this.QueryMsg.Top:0;
            document.documentElement.scrollTop = this.gundongTop ? this.gundongTop : 0;//跳转各详情页后通过面包屑回跳保留跳转前的页面滚动高度
            this.bigTap = this.QueryMsg.bigTap;
            this.bigtapvalue = this.QueryMsg.bigTap;
            const mb_bigtap = this.QueryMsg.bigTap;
            this.currentPage = JSON.parse(this.QueryMsg.page);
            this.page = this.QueryMsg.page;
            this.page_size = this.QueryMsg.pageSize;
            if (mb_bigtap == 1) {
              this.systypes_id =this.QueryMsg.feleiDid && this.QueryMsg.feleiDid == 1000?4: 1;
              this.bigtapvalue = 1;
              this.bigTitle = '同步资源'
              this.tbzyChosed.bookid = this.kejianbooks_id = this.QueryMsg.bookId?this.QueryMsg.bookId:''; //当前书本id
              this.tbzyChosed.booktitle = this.kejianbooks_title = this.QueryMsg.bookTitle?this.QueryMsg.bookTitle:''; //当前学习的书本名
              this.kejianchapters_id = this.QueryMsg.mulu3id?this.QueryMsg.mulu3id:this.QueryMsg.mulu2id?this.QueryMsg.mulu2id:this.QueryMsg.mulu1id; //当前学习的目录id
              this.tbzyChosed.mulu1id = this.QueryMsg.mulu1id?this.QueryMsg.mulu1id:'';//同步资源分类下的目录id
              this.tbzyChosed.mulu1title = this.QueryMsg.mulu1title?this.QueryMsg.mulu1title:'';//同步资源分类下的目录名称
              this.tbzyChosed.mulu2id = this.QueryMsg.mulu2id?this.QueryMsg.mulu2id:'';//同步资源分类下的目录id
              this.tbzyChosed.mulu2title = this.QueryMsg.mulu2title?this.QueryMsg.mulu2title:'';//同步资源分类下的目录名称
              this.tbzyChosed.mulu3id = this.QueryMsg.mulu3id?this.QueryMsg.mulu3id:'';//同步资源分类下的目录id
              this.tbzyChosed.mulu3title = this.QueryMsg.mulu3title?this.QueryMsg.mulu3title:'';//同步资源分类下的目录名称
              this.fenleiTitle = this.QueryMsg.fenleiTitle?this.QueryMsg.fenleiTitle:'';//同步资源分类名
              this.kejianfl_id = this.QueryMsg.feleiDid?this.QueryMsg.feleiDid:'';//同步资源分类id
              this.getkejianfl(); //获取课件分类
              setTimeout(()=>{
                this.getallMuluByPm(); //详情页回调或url地址复制的书本和目录id来获取选中的书本目录树
              },200)
            } else if (mb_bigtap == 2) {
              this.bigTitle = '试卷'
              this.systypes_id = 2;
              this.bigtapvalue = 2;
              this.nianji_id = "";
              this.kejianfl_id = 0;

              this.sjFlTitle = this.QueryMsg.sjFlTitle?this.QueryMsg.sjFlTitle:'全部', //试卷类型名
              this.kejiantag_id = this.QueryMsg.sjFlId?this.QueryMsg.sjFlId:'', //试卷类型id
              this.sjNjTitle = this.QueryMsg.sjNjTitle?this.QueryMsg.sjNjTitle:'全部', //试卷选中年级名
              this.sjNjId = this.QueryMsg.sjNjId?this.QueryMsg.sjNjId:'', //试卷选中年级id
              this.sjDqTitle = this.QueryMsg.sjDqTitle?this.QueryMsg.sjDqTitle:'', //试卷选中地区名
              this.sjDqId = this.QueryMsg.sjDqId?this.QueryMsg.sjDqId:'', //试卷选中地区id
              this.sjNfTitle = this.QueryMsg.sjNfTitle?this.QueryMsg.sjNfTitle:'全部', //试卷选中年份名
              this.sjNfId = this.QueryMsg.sjNfId?this.QueryMsg.sjNfId:'', //试卷选中年份id
              this.getkejianlists();
            } else if (mb_bigtap == 3) {
              this.bigTitle = '素材'
              this.systypes_id = 3;
              this.bigtapvalue = 3;
              this.kejianfl_id = 0;
              this.scFlTitle = this.QueryMsg.scFlTitle?this.QueryMsg.scFlTitle:'全部', //素材类型名
              this.kejiantag_id = this.scFlId = this.QueryMsg.scFlId?this.QueryMsg.scFlId:'', //素材类型id
              this.scTimeTitle = this.QueryMsg.scTimeTitle?this.QueryMsg.scTimeTitle:'全部', //素材时间名
              this.scTimeId = this.QueryMsg.scTimeId?this.QueryMsg.scTimeId:'', //素材时间端
              this.getkejianlists();
            } else if (mb_bigtap == 4) {
              this.bigTitle = '教学课'
              this.bigtapvalue = 4;
              this.kejianfl_id = 0;
              this.jxkFlTitle = this.QueryMsg.jxkFlTitle?this.QueryMsg.jxkFlTitle:'全部', //教学课分类名
              this.classof = this.QueryMsg.jxkFlId?this.QueryMsg.jxkFlId:'all', //教学课分类id
              this.getjxk();
            } else if (mb_bigtap == 5) {
              this.bigTitle = '资源包'
              this.bigtapvalue = 5;
              this.kejianfl_id = 0;
              this.zybFlTitle = this.QueryMsg.zybFlTitle;
              this.ziyuanbaochapters_id = this.QueryMsg.zybFlId;
              this.getkejianbaolists();
            }
          }else{
          //  this.tbzyChosed.bookid = this.kejianbooks_id = data.kejianbooks_id
          //  this.tbzyChosed.booktitle = this.kejianbooks_title = data.kejianbooks_title
          //  this.tbzyChosed.mulu1id = this.kejianchapters_id = data.kejianchapters_id
          //  this.tbzyChosed.mulu1title = this.kejianchapters_title = data.kejianchapters_title
           this.kejianfl_id = 0;
           this.fenleiTitle = '全部';
           this.getkejianfl(); //获取课件分类
            setTimeout(()=>{
              this.getallMulu(); //无任何参数跳转的情况下根据当前科目版本的书本和目录id来获取选中的书本目录树
            },300)
          }
          this.getshijaunfl(); //获取试卷分类
          this.getsucaifl(); //获取试卷分类
          this.getdqnf(); //获取试卷分类的年份地区
        });
        if(!localStorage.getItem('tckm')){
          //获取年级列表数据
          nianjilists({ md5key: localStorage.getItem("md5key") }).then(
            (res) => {
              const data = res.retRes;
              if (res.retInt == 1) {
                this.nianjiList = data;
              }
            }
          );
          //获取科目列表
          kemulists({ md5key: localStorage.getItem("md5key") }).then(
            (res) => {
              const data = res.retRes;
              if (res.retInt == 1) {
                this.classList = data;
              }
            }
          );
          setTimeout(() => {
            //获取教学版本列表
            versionslists({
              md5key: localStorage.getItem("md5key"),
              kemu_id: this.radio1 ? this.radio1 : "1",
            }).then((res) => {
              const data = res.retRes;
              if (res.retInt == 1) {
                this.banbenList = data;
              }
            });
          }, 200);
          this.dialogTableVisible = true;
        }
        
      }
      
    })


    //获取资源包下的分类（目录） 不需要传参数
    // tjlists_dy({
    //   md5key: localStorage.getItem("md5key"),
    // }).then((res) => {
    //   this.ziyuanbaochaptersLists = res.retRes; //资源包目录列表
    //   //资源包模块默认选中第一个单元，如有回调参数再修改
    //   this.ziyuanbaochaptersLists.length > 0
    //     ? this.ziyuanbaochaptersLists[0].dy_id
    //     : 0;
    // });

    //获取当前科目和版本
    // nowkemu({
    //   md5key: localStorage.getItem("md5key"),
    // }).then((res) => {
    //   console.log(res, "当前科目和版本");
    //   const data = res.retRes;
    //   this.status = data.is_now; //是否当前

    //   //用户个人信息里的年级id
    //   this.dingzhiNj_id = data.nianji_id;
    //   if(data.kemu_id == 1 || data.kemu_id == 3){
    //     this.menus = [
    //       { id: "1", title: "同步资源" },
    //       { id: "2", title: "试卷" },
    //       { id: "3", title: "素材库" },
    //       { id: "4", title: "教学课" },
    //     ]
    //   }else{
    //     this.menus = [
    //       { id: "1", title: "同步资源" },
    //       { id: "2", title: "试卷" },
    //       { id: "3", title: "素材库" },
    //       // { id: "4", title: "教学课" },
    //     ]
    //   }

    //   //如果当前的版本或科目为0，跳转到选择版本页
    //   if (data.kejianversions_id == 0 || data.kemu_id == 0) {
    //     this.$alert("您还未选择学科或版本，请先前往选择", "温馨提示", {
    //       confirmButtonText: "确定",
    //       callback: () => {
    //         this.$router.push({
    //           name: "ChangeClass",
    //         });
    //       },
    //     });
    //     //如果当前的计划开始时间结束时间不存在或科目为0，跳转到设置教学计划
    //   } else if (data.have_plan == 0) {
    //     this.$alert("您目前还没有教学计划，请先前往设置", "温馨提示", {
    //       confirmButtonText: "确定",
    //       callback: () => {
    //         this.$router.push({
    //           name: "MyTeachPlan",
    //         });
    //       },
    //     });
    //   } else {
    //     //从当前科目和版本接口中获取的数据
    //     this.kemu_id = data.kemu_id; //当前科目id
    //     this.kejianversions_title = data.kejianversions_title; //当前版本名
    //     this.kejianversions_id = data.kejianversions_id; //当前版本id
        
    //     //获取书本列表
    //     bookslists({
    //       md5key: localStorage.getItem("md5key"),
    //       kejianversions_id: this.kejianversions_id,
    //       kemu_id: this.kemu_id,
    //     }).then((res) => {
    //       this.booksList = res.retRes;
    //       //如果是首页或精选资源页的查看更多跳转过来
    //       if (this.QueryMsg.fliter) {
    //         document.documentElement.scrollTop = 0
    //         if (this.QueryMsg.fliter == "zy") {
    //           this.kejianbooks_id = this.tbzyChosed.bookid = ''
    //           this.kejianbooks_title = this.tbzyChosed.booktitle = ''
    //           this.kejianchapters_id = this.tbzyChosed.mulu1id = "";
    //           this.kejianchapters_title = this.tbzyChosed.mulu1title = "";
    //           this.getkejianfl(); //获取课件分类
    //         } else if (this.QueryMsg.fliter == "sj") {
    //           this.bigtapvalue = 2;
    //           this.bigTap = "2";
    //           this.systypes_id = 2;
    //           this.nianji_id = "";
    //           this.getkejianfl(); //获取课件分类
    //         } else if (this.QueryMsg.fliter == "sc") {
    //           this.systypes_id = 3;
    //           this.bigTap = "3";
    //           this.bigtapvalue = 3;
    //           this.getkejianfl(); //获取课件分类
    //         }
    //       }else if(this.QueryMsg.from && this.QueryMsg.bigTap){
    //         //各详情页面包屑回跳过来的
    //         this.gundongTop = this.QueryMsg.Top?this.QueryMsg.Top:0;
    //         document.documentElement.scrollTop = this.gundongTop ? this.gundongTop : 0;//跳转各详情页后通过面包屑回跳保留跳转前的页面滚动高度
    //         this.bigTap = this.QueryMsg.bigTap;
    //         this.bigtapvalue = this.QueryMsg.bigTap;
    //         const mb_bigtap = this.QueryMsg.bigTap;
    //         this.currentPage = JSON.parse(this.QueryMsg.page);
    //         this.page = this.QueryMsg.page;
    //         this.page_size = this.QueryMsg.pageSize;
    //         if (mb_bigtap == 1) {
    //           this.systypes_id =this.QueryMsg.feleiDid && this.QueryMsg.feleiDid == 1000?4: 1;
    //           this.bigtapvalue = 1;
    //           this.bigTitle = '同步资源'
    //           this.tbzyChosed.bookid = this.kejianbooks_id = this.QueryMsg.bookId?this.QueryMsg.bookId:''; //当前书本id
    //           this.tbzyChosed.booktitle = this.kejianbooks_title = this.QueryMsg.bookTitle?this.QueryMsg.bookTitle:''; //当前学习的书本名
    //           this.kejianchapters_id = this.QueryMsg.mulu3id?this.QueryMsg.mulu3id:this.QueryMsg.mulu2id?this.QueryMsg.mulu2id:this.QueryMsg.mulu1id; //当前学习的目录id
    //           this.tbzyChosed.mulu1id = this.QueryMsg.mulu1id?this.QueryMsg.mulu1id:'';//同步资源分类下的目录id
    //           this.tbzyChosed.mulu1title = this.QueryMsg.mulu1title?this.QueryMsg.mulu1title:'';//同步资源分类下的目录名称
    //           this.tbzyChosed.mulu2id = this.QueryMsg.mulu2id?this.QueryMsg.mulu2id:'';//同步资源分类下的目录id
    //           this.tbzyChosed.mulu2title = this.QueryMsg.mulu2title?this.QueryMsg.mulu2title:'';//同步资源分类下的目录名称
    //           this.tbzyChosed.mulu3id = this.QueryMsg.mulu3id?this.QueryMsg.mulu3id:'';//同步资源分类下的目录id
    //           this.tbzyChosed.mulu3title = this.QueryMsg.mulu3title?this.QueryMsg.mulu3title:'';//同步资源分类下的目录名称
    //           this.fenleiTitle = this.QueryMsg.fenleiTitle?this.QueryMsg.fenleiTitle:'';//同步资源分类名
    //           this.kejianfl_id = this.QueryMsg.feleiDid?this.QueryMsg.feleiDid:'';//同步资源分类id
    //           this.getkejianfl(); //获取课件分类
    //           setTimeout(()=>{
    //             this.getallMuluByPm(); //详情页回调或url地址复制的书本和目录id来获取选中的书本目录树
    //           },200)
    //         } else if (mb_bigtap == 2) {
    //           this.bigTitle = '试卷'
    //           this.systypes_id = 2;
    //           this.bigtapvalue = 2;
    //           this.nianji_id = "";
    //           this.kejianfl_id = 0;

    //           this.sjFlTitle = this.QueryMsg.sjFlTitle?this.QueryMsg.sjFlTitle:'全部', //试卷类型名
    //           this.kejiantag_id = this.QueryMsg.sjFlId?this.QueryMsg.sjFlId:'', //试卷类型id
    //           this.sjNjTitle = this.QueryMsg.sjNjTitle?this.QueryMsg.sjNjTitle:'全部', //试卷选中年级名
    //           this.sjNjId = this.QueryMsg.sjNjId?this.QueryMsg.sjNjId:'', //试卷选中年级id
    //           this.sjDqTitle = this.QueryMsg.sjDqTitle?this.QueryMsg.sjDqTitle:'', //试卷选中地区名
    //           this.sjDqId = this.QueryMsg.sjDqId?this.QueryMsg.sjDqId:'', //试卷选中地区id
    //           this.sjNfTitle = this.QueryMsg.sjNfTitle?this.QueryMsg.sjNfTitle:'全部', //试卷选中年份名
    //           this.sjNfId = this.QueryMsg.sjNfId?this.QueryMsg.sjNfId:'', //试卷选中年份id
    //           this.getkejianlists();
    //         } else if (mb_bigtap == 3) {
    //           this.bigTitle = '素材'
    //           this.systypes_id = 3;
    //           this.bigtapvalue = 3;
    //           this.kejianfl_id = 0;
    //           this.scFlTitle = this.QueryMsg.scFlTitle?this.QueryMsg.scFlTitle:'全部', //素材类型名
    //           this.kejiantag_id = this.scFlId = this.QueryMsg.scFlId?this.QueryMsg.scFlId:'', //素材类型id
    //           this.scTimeTitle = this.QueryMsg.scTimeTitle?this.QueryMsg.scTimeTitle:'全部', //素材时间名
    //           this.scTimeId = this.QueryMsg.scTimeId?this.QueryMsg.scTimeId:'', //素材时间端
    //           this.getkejianlists();
    //         } else if (mb_bigtap == 4) {
    //           this.bigTitle = '教学课'
    //           this.bigtapvalue = 4;
    //           this.kejianfl_id = 0;
    //           this.jxkFlTitle = this.QueryMsg.jxkFlTitle?this.QueryMsg.jxkFlTitle:'全部', //教学课分类名
    //           this.classof = this.QueryMsg.jxkFlId?this.QueryMsg.jxkFlId:'all', //教学课分类id
    //           this.getjxk();
    //         } else if (mb_bigtap == 5) {
    //           this.bigTitle = '资源包'
    //           this.bigtapvalue = 5;
    //           this.kejianfl_id = 0;
    //           this.zybFlTitle = this.QueryMsg.zybFlTitle;
    //           this.ziyuanbaochapters_id = this.QueryMsg.zybFlId;
    //           this.getkejianbaolists();
    //         }
    //       }else{
    //        this.tbzyChosed.bookid = this.kejianbooks_id = data.kejianbooks_id
    //        this.tbzyChosed.booktitle = this.kejianbooks_title = data.kejianbooks_title
    //        this.tbzyChosed.mulu1id = this.kejianchapters_id = data.kejianchapters_id
    //        this.tbzyChosed.mulu1title = this.kejianchapters_title = data.kejianchapters_title
    //        this.kejianfl_id = 0;
    //        this.fenleiTitle = '全部';
    //        this.getkejianfl(); //获取课件分类
    //         setTimeout(()=>{
    //           this.getallMulu(); //无任何参数跳转的情况下根据当前科目版本的书本和目录id来获取选中的书本目录树
    //         },300)
    //       }
    //       this.getshijaunfl(); //获取试卷分类
    //       this.getsucaifl(); //获取试卷分类
    //       this.getdqnf(); //获取试卷分类的年份地区
    //     });
    //   }
    // });
  },
  mounted() {
    //  getgoodsweekpopup({
    //   md5key: localStorage.getItem("md5key"),
    // }).then(res=>{
    //   if(res.retRes == 1){
    //     this.gxtxShow = true
    //     this.gxkf_file_url = this.kefuMsg.qwkf_file_url
    //   }
    // })
  },
  methods: {
    //切换科目后，版本会更新为选择的科目版本
    changeKemu(id) {
      this.radio1 = id;
      this.radio2 = "";
      //获取教学版本列表
      versionslists({
        kemu_id: this.radio1,
      }).then((res) => {
        // console.log(res, "版本列表");
        const data = res.retRes;
        if (res.retInt == 1) {
          this.banbenList = data;
        }
      });
    },
    //提交设置的科目和版本
    submit() {
      // console.log(this.radio3, this.radio1, this.radio2);
      if (!this.radio1) {
        this.$message({
          message: "请选择学科",
          duration: 1000,
          showClose: false,
        });
      } else if (!this.radio2) {
        this.$message({
          message: "请选择版本",
          duration: 1000,
          showClose: false,
          offset: 300,
        });
      } else if (!this.radio3) {
        this.$message({
          message: "请选择年级",
          duration: 1000,
          showClose: false,
          offset: 300,
        });
      } else {
        this.kemu_id = this.radio1;
        this.nianji_id = this.radio3;
        this.kejianversions_id = this.radio2;
        localStorage.setItem('tckm',this.kemu_id)
        localStorage.setItem('tcnj',this.nianji_id)
        localStorage.setItem('tcbb',this.kejianversions_id)
        
        versionslists({
          md5key: localStorage.getItem("md5key"),
          kemu_id: this.kemu_id,
        }).then((res) => {
          const data = res.retRes;
          this.banbenList = data;
          data.forEach(item=>{
            if(item.id == this.kejianversions_id){
              this.kejianversions_title = item.title
            }
          })
        });
        //获取书本列表
        bookslists({
          md5key: localStorage.getItem("md5key"),
          kejianversions_id: this.kejianversions_id,
          kemu_id: this.kemu_id,
        }).then((res) => {
          this.booksList = res.retRes;
          //如果是首页或精选资源页的查看更多跳转过来
          if (this.QueryMsg.fliter) {
            document.documentElement.scrollTop = 0
            if (this.QueryMsg.fliter == "zy") {
              this.kejianbooks_id = this.tbzyChosed.bookid = ''
              this.kejianbooks_title = this.tbzyChosed.booktitle = ''
              this.kejianchapters_id = this.tbzyChosed.mulu1id = "";
              this.kejianchapters_title = this.tbzyChosed.mulu1title = "";
              this.getkejianfl(); //获取课件分类
            } else if (this.QueryMsg.fliter == "sj") {
              this.bigtapvalue = 2;
              this.bigTap = "2";
              this.systypes_id = 2;
              this.nianji_id = "";
              this.getkejianfl(); //获取课件分类
            } else if (this.QueryMsg.fliter == "sc") {
              this.systypes_id = 3;
              this.bigTap = "3";
              this.bigtapvalue = 3;
              this.getkejianfl(); //获取课件分类
            }
          }else if(this.QueryMsg.from && this.QueryMsg.bigTap){
            //各详情页面包屑回跳过来的
            this.gundongTop = this.QueryMsg.Top?this.QueryMsg.Top:0;
            document.documentElement.scrollTop = this.gundongTop ? this.gundongTop : 0;//跳转各详情页后通过面包屑回跳保留跳转前的页面滚动高度
            this.bigTap = this.QueryMsg.bigTap;
            this.bigtapvalue = this.QueryMsg.bigTap;
            const mb_bigtap = this.QueryMsg.bigTap;
            this.currentPage = JSON.parse(this.QueryMsg.page);
            this.page = this.QueryMsg.page;
            this.page_size = this.QueryMsg.pageSize;
            if (mb_bigtap == 1) {
              this.systypes_id =this.QueryMsg.feleiDid && this.QueryMsg.feleiDid == 1000?4: 1;
              this.bigtapvalue = 1;
              this.bigTitle = '同步资源'
              this.tbzyChosed.bookid = this.kejianbooks_id = this.QueryMsg.bookId?this.QueryMsg.bookId:''; //当前书本id
              this.tbzyChosed.booktitle = this.kejianbooks_title = this.QueryMsg.bookTitle?this.QueryMsg.bookTitle:''; //当前学习的书本名
              this.kejianchapters_id = this.QueryMsg.mulu3id?this.QueryMsg.mulu3id:this.QueryMsg.mulu2id?this.QueryMsg.mulu2id:this.QueryMsg.mulu1id; //当前学习的目录id
              this.tbzyChosed.mulu1id = this.QueryMsg.mulu1id?this.QueryMsg.mulu1id:'';//同步资源分类下的目录id
              this.tbzyChosed.mulu1title = this.QueryMsg.mulu1title?this.QueryMsg.mulu1title:'';//同步资源分类下的目录名称
              this.tbzyChosed.mulu2id = this.QueryMsg.mulu2id?this.QueryMsg.mulu2id:'';//同步资源分类下的目录id
              this.tbzyChosed.mulu2title = this.QueryMsg.mulu2title?this.QueryMsg.mulu2title:'';//同步资源分类下的目录名称
              this.tbzyChosed.mulu3id = this.QueryMsg.mulu3id?this.QueryMsg.mulu3id:'';//同步资源分类下的目录id
              this.tbzyChosed.mulu3title = this.QueryMsg.mulu3title?this.QueryMsg.mulu3title:'';//同步资源分类下的目录名称
              this.fenleiTitle = this.QueryMsg.fenleiTitle?this.QueryMsg.fenleiTitle:'';//同步资源分类名
              this.kejianfl_id = this.QueryMsg.feleiDid?this.QueryMsg.feleiDid:'';//同步资源分类id
              this.getkejianfl(); //获取课件分类
              setTimeout(()=>{
                this.getallMuluByPm(); //详情页回调或url地址复制的书本和目录id来获取选中的书本目录树
              },200)
            } else if (mb_bigtap == 2) {
              this.bigTitle = '试卷'
              this.systypes_id = 2;
              this.bigtapvalue = 2;
              this.nianji_id = "";
              this.kejianfl_id = 0;

              this.sjFlTitle = this.QueryMsg.sjFlTitle?this.QueryMsg.sjFlTitle:'全部', //试卷类型名
              this.kejiantag_id = this.QueryMsg.sjFlId?this.QueryMsg.sjFlId:'', //试卷类型id
              this.sjNjTitle = this.QueryMsg.sjNjTitle?this.QueryMsg.sjNjTitle:'全部', //试卷选中年级名
              this.sjNjId = this.QueryMsg.sjNjId?this.QueryMsg.sjNjId:'', //试卷选中年级id
              this.sjDqTitle = this.QueryMsg.sjDqTitle?this.QueryMsg.sjDqTitle:'', //试卷选中地区名
              this.sjDqId = this.QueryMsg.sjDqId?this.QueryMsg.sjDqId:'', //试卷选中地区id
              this.sjNfTitle = this.QueryMsg.sjNfTitle?this.QueryMsg.sjNfTitle:'全部', //试卷选中年份名
              this.sjNfId = this.QueryMsg.sjNfId?this.QueryMsg.sjNfId:'', //试卷选中年份id
              this.getkejianlists();
            } else if (mb_bigtap == 3) {
              this.bigTitle = '素材'
              this.systypes_id = 3;
              this.bigtapvalue = 3;
              this.kejianfl_id = 0;
              this.scFlTitle = this.QueryMsg.scFlTitle?this.QueryMsg.scFlTitle:'全部', //素材类型名
              this.kejiantag_id = this.scFlId = this.QueryMsg.scFlId?this.QueryMsg.scFlId:'', //素材类型id
              this.scTimeTitle = this.QueryMsg.scTimeTitle?this.QueryMsg.scTimeTitle:'全部', //素材时间名
              this.scTimeId = this.QueryMsg.scTimeId?this.QueryMsg.scTimeId:'', //素材时间端
              this.getkejianlists();
            } else if (mb_bigtap == 4) {
              this.bigTitle = '教学课'
              this.bigtapvalue = 4;
              this.kejianfl_id = 0;
              this.jxkFlTitle = this.QueryMsg.jxkFlTitle?this.QueryMsg.jxkFlTitle:'全部', //教学课分类名
              this.classof = this.QueryMsg.jxkFlId?this.QueryMsg.jxkFlId:'all', //教学课分类id
              this.getjxk();
            } else if (mb_bigtap == 5) {
              this.bigTitle = '资源包'
              this.bigtapvalue = 5;
              this.kejianfl_id = 0;
              this.zybFlTitle = this.QueryMsg.zybFlTitle;
              this.ziyuanbaochapters_id = this.QueryMsg.zybFlId;
              this.getkejianbaolists();
            }
          }else{
          //  this.tbzyChosed.bookid = this.kejianbooks_id = data.kejianbooks_id
          //  this.tbzyChosed.booktitle = this.kejianbooks_title = data.kejianbooks_title
          //  this.tbzyChosed.mulu1id = this.kejianchapters_id = data.kejianchapters_id
          //  this.tbzyChosed.mulu1title = this.kejianchapters_title = data.kejianchapters_title
           this.kejianfl_id = 0;
           this.fenleiTitle = '全部';
           this.getkejianfl(); //获取课件分类
            setTimeout(()=>{
              this.getallMulu(); //无任何参数跳转的情况下根据当前科目版本的书本和目录id来获取选中的书本目录树
            },300)
          }
          this.getshijaunfl(); //获取试卷分类
          this.getsucaifl(); //获取试卷分类
          this.getdqnf(); //获取试卷分类的年份地区
        });
        this.dialogTableVisible = false;
      }
    },
    //关闭更新弹窗
    gxtcClose(){
      this.gxtxShow = false
      closepopup({
        md5key: localStorage.getItem("md5key"),
      })
    },
    //收藏
    sckj(id){
      const scarr = []
      scarr.push(id)
      create_accountzysc({
        md5key: localStorage.getItem("md5key"),
        ids:scarr,
        type_id: 1,
        status: 1,
      }).then(res=>{
        if(res.retInt == 1){
          this.getkejianlists();
        }
      })
    },
    //取消收藏
    qxsc(id){
      const qxscarr = []
      qxscarr.push(id)
      create_accountzysc({
        md5key: localStorage.getItem("md5key"),
        ids:qxscarr,
        type_id: 1,
        status: 2,
      }).then(res=>{
        if(res.retInt == 1){
          this.getkejianlists();
        }
      })
    },
    //获取两年前今天的时间戳
    getBefore2Year(time){
      const before2 = new Date().getTime() - 3600 *24 * 365 *1 *1000
      if(time *1000 > before2){
        return true
      }
    },
    //无参数获取单元目录
    getallMulu(){
      if(this.kejianbooks_id){
        this.tbzyChosed.bookindex = this.booksList.findIndex(item=>{return item.id == this.kejianbooks_id})
        this.tbzyChosed.mulu1 = document.querySelectorAll('.bookBox')[this.tbzyChosed.bookindex]
        chapterslists({
          md5key: localStorage.getItem("md5key"),
          kejianbooks_id: this.kejianbooks_id,
          pid:0,
        }).then((res)=>{
          this.mululist1 = res.retRes;
          console.log(res.retRes, "书本目录");
          let num = res.retRes.length
          this.tbzyChosed.mulu1.style.height = (num+1) * this.muluHeight +'px'
          if(this.kejianchapters_id){
           setTimeout(()=>{
             this.tbzyChosed.mulu1index = this.mululist1.findIndex(item=>{return item.id == this.tbzyChosed.mulu1id})
              this.tbzyChosed.mulu2 = document.querySelectorAll('.bookBox')[this.tbzyChosed.bookindex].childNodes[this.tbzyChosed.mulu1index+1]
              chapterslists({
                md5key: localStorage.getItem("md5key"),
                kejianbooks_id: this.tbzyChosed.bookid,
                pid: this.tbzyChosed.mulu1id,
              }).then((res) => {
                this.mululist2 = res.retRes;
                console.log(res, "书本二级目录");
                let num = res.retRes.length
                this.tbzyChosed.mulu1.style.height = (this.mululist1.length+num+1)*this.muluHeight + 'px'
                this.tbzyChosed.mulu2.style.height = (this.mululist2.length+1) * this.muluHeight + 'px'
              });
           },100)
          }else{
            return
          }
        })
      }
    },
    //有参数获取单元目录
    getallMuluByPm(){
      if(this.tbzyChosed.bookid){
        this.tbzyChosed.bookindex = this.booksList.findIndex(item=>{return item.id == this.kejianbooks_id})
        this.tbzyChosed.mulu1 = document.querySelectorAll('.bookBox')[this.tbzyChosed.bookindex]
        chapterslists({
          md5key: localStorage.getItem("md5key"),
          kejianbooks_id: this.tbzyChosed.bookid,
          pid:0,
        }).then((res)=>{
          this.mululist1 = res.retRes;
          let num = res.retRes.length
          this.tbzyChosed.mulu1.style.height = (num+1) * this.muluHeight + 'px'
          if(this.tbzyChosed.mulu1id){
            setTimeout(()=>{
              this.tbzyChosed.mulu1index = this.mululist1.findIndex(item=>{return item.id == this.tbzyChosed.mulu1id})
              this.tbzyChosed.mulu2 = document.querySelectorAll('.bookBox')[this.tbzyChosed.bookindex].childNodes[this.tbzyChosed.mulu1index+1]
              chapterslists({
                md5key: localStorage.getItem("md5key"),
                kejianbooks_id: this.tbzyChosed.bookid,
                pid: this.tbzyChosed.mulu1id,
              }).then((res) => {
                this.mululist2 = res.retRes;
                let num = res.retRes.length
                this.tbzyChosed.mulu1.style.height = (this.mululist1.length+num+1)*this.muluHeight + 'px'
                this.tbzyChosed.mulu2.style.height = (this.mululist2.length+1) * this.muluHeight + 'px'
                if(this.tbzyChosed.mulu2id){
                 setTimeout(()=>{
                    this.tbzyChosed.mulu2index = this.mululist2.findIndex(item=>{return item.id == this.tbzyChosed.mulu2id})
                    this.tbzyChosed.mulu3 = document.querySelectorAll('.bookBox')[this.tbzyChosed.bookindex].childNodes[this.tbzyChosed.mulu1index+1].childNodes[this.tbzyChosed.mulu2index+1]
                    chapterslists({
                      md5key: localStorage.getItem("md5key"),
                      kejianbooks_id: this.tbzyChosed.bookid,
                      pid: this.tbzyChosed.mulu2id,
                    }).then((res) => {
                      this.mululist3 = res.retRes;
                      let num = res.retRes.length
                      this.tbzyChosed.mulu1.style.height = (this.mululist1.length+this.mululist2.length+num+1)*this.muluHeight + 'px'
                      this.tbzyChosed.mulu2.style.height = (this.mululist2.length+num+1)*this.muluHeight + 'px'
                      this.tbzyChosed.mulu3.style.height = (num+1) * this.muluHeight + 'px'
                    });
                 },200)
                }
              });
            },200)
          }else{
            return
          }
        })
      }
    },
    getmulu1(id,pid,title,index){
      document.documentElement.scrollTop = 0;
      this.tbzyChosed.pid = pid
      this.tbzyChosed.mulu1id = ''
      this.tbzyChosed.mulu1title = ''
      this.tbzyChosed.mulu2id = ''
      this.tbzyChosed.mulu2title = ''
      this.tbzyChosed.mulu3id = ''
      this.tbzyChosed.mulu3title = ''
      console.log(this.tbzyChosed)
      this.tbzyChosed.mulu1 = document.querySelectorAll('.bookBox')[index]
      if(this.tbzyChosed.bookid == id){
        this.tbzyChosed.mulu1.style.height = this.muluHeight + 'px'
        setTimeout(()=>{
          this.kejianbooks_id = this.tbzyChosed.bookid = ''
          this.kejianchapters_id = ''
          this.tbzyChosed.booktitle = ''
          this.mululist1 = []
          this.changeUrl();//更改路由地址栏信息
          this.getkejianfl(); //获取课件分类
        },500)
      }else{
        document.querySelectorAll('.bookBox').forEach(item=>{
            item.style.height = this.bookHeight + "px"
        })
        this.kejianbooks_id = this.tbzyChosed.bookid = id
        this.kejianchapters_id = ''
        this.tbzyChosed.booktitle = title
        this.tbzyChosed.bookindex = index
        this.getkejianfl(); //获取课件分类
        chapterslists({
          md5key: localStorage.getItem("md5key"),
          kejianbooks_id: id,
          pid: this.tbzyChosed.pid,
        }).then((res) => {
          this.mululist1 = res.retRes;
          console.log(res.retRes, "书本目录");
          let num = res.retRes.length
          this.tbzyChosed.mulu1.style.height = (num+1) * this.muluHeight +'px'
        });
        this.changeUrl();//更改路由地址栏信息
      }
    },
    getmulu2(pid,title,index,index1){
      this.tbzyChosed.pid = pid
      this.tbzyChosed.mulu2id = ''
      this.tbzyChosed.mulu2title = ''
      this.tbzyChosed.mulu3id = ''
      this.tbzyChosed.mulu3title = ''
      this.tbzyChosed.mulu2 = document.querySelectorAll('.bookBox')[index].childNodes[index1+1]
      console.log(this.tbzyChosed.mulu2)
      if(this.tbzyChosed.mulu1id == pid){
        this.tbzyChosed.mulu1.style.height = (this.mululist1.length +1)*this.muluHeight + 'px'
        this.tbzyChosed.mulu2.style.height = this.muluHeight + 'px'
        setTimeout(()=>{
          this.kejianchapters_id = this.tbzyChosed.mulu1id = ''
          this.tbzyChosed.mulu1title = ''
          this.getkejianfl(); //获取课件分类
          this.mululist2 = []
          this.changeUrl();//更改路由地址栏信息
        },500)
      }else{
        document.querySelectorAll('.mulu1Box').forEach(item=>{
            item.style.height = this.muluHeight + 'px'
        })
        this.kejianchapters_id = this.tbzyChosed.mulu1id = pid
        this.tbzyChosed.mulu1title = title
        this.getkejianfl(); //获取课件分类
        chapterslists({
          md5key: localStorage.getItem("md5key"),
          kejianbooks_id: this.tbzyChosed.bookid,
          pid: this.tbzyChosed.pid,
        }).then((res) => {
          this.mululist2 = res.retRes;
          console.log(res, "书本二级目录");
          let num = res.retRes.length
          this.tbzyChosed.mulu1.style.height = (this.mululist1.length+num+1)*this.muluHeight + 'px'
          this.tbzyChosed.mulu2.style.height = (this.mululist2.length+1) * this.muluHeight + 'px'
        });
        this.changeUrl();//更改路由地址栏信息
      }
    },
    getmulu3(pid,title,index,index1,index2){
      this.tbzyChosed.pid = pid
      this.tbzyChosed.mulu3id = ''
      this.tbzyChosed.mulu3title = ''
      this.tbzyChosed.mulu3 = document.querySelectorAll('.bookBox')[index].childNodes[index1+1].childNodes[index2+1]
      if(this.tbzyChosed.mulu2id == pid){
        this.tbzyChosed.mulu1.style.height = (this.mululist1.length+this.mululist2.length +1)*this.muluHeight + 'px'
        this.tbzyChosed.mulu2.style.height = (this.mululist2.length+1)*this.muluHeight + 'px'
        this.tbzyChosed.mulu3.style.height = this.muluHeight + 'px'
        setTimeout(()=>{
          this.kejianchapters_id = this.tbzyChosed.mulu1id
          this.tbzyChosed.mulu2id = ''
          this.tbzyChosed.mulu2title = ''
          this.mululist3 = []
          this.getkejianfl(); //获取课件分类
          this.changeUrl();//更改路由地址栏信息
        },500)
      }else{
        document.querySelectorAll('.mulu2Box').forEach(item=>{
            item.style.height = this.muluHeight + 'px'
        })
        this.kejianchapters_id = this.tbzyChosed.mulu2id = pid
        this.tbzyChosed.mulu2title = title
        this.getkejianfl(); //获取课件分类
        chapterslists({
          md5key: localStorage.getItem("md5key"),
          kejianbooks_id: this.tbzyChosed.bookid,
          pid: this.tbzyChosed.pid,
        }).then((res) => {
          this.mululist3 = res.retRes;
          console.log(res, "书本二级目录");
          let num = res.retRes.length
          this.tbzyChosed.mulu1.style.height = (this.mululist1.length+this.mululist2.length+num+1)*this.muluHeight + 'px'
          this.tbzyChosed.mulu2.style.height = (this.mululist2.length+num+1)*this.muluHeight + 'px'
          this.tbzyChosed.mulu3.style.height = (num+1) * this.muluHeight + 'px'
        });
        this.changeUrl();//更改路由地址栏信息
      }
    },
    getmulu4(pid,title){
      this.tbzyChosed.pid = pid
      // this.mulu3 = document.querySelectorAll('.bookBox')[index].childNodes[index1+1].childNodes[index2+1]
      // if(this.tbzyChosed.mulu3id == pid){
        // this.tbzyChosed.mulu1.style.height = (this.mululist1.length+this.mululist2.length +1)*44 + 'px'
        // this.tbzyChosed.mulu2.style.height = (this.mululist2.length+1)*44 + 'px'
        // this.tbzyChosed.mulu3.style.height = '44px'
        // setTimeout(()=>{
          // this.tbzyChosed.mulu3id = ''
          // this.tbzyChosed.mulu3title = ''
        //   this.mululist3 = []
        // },500)
      // }else{
        // document.querySelectorAll('.mulu2Box').forEach(item=>{
        //     item.style.height = "44px"
        // })
       this.kejianchapters_id = this.tbzyChosed.mulu3id = pid
        this.tbzyChosed.mulu3title = title
        this.changeUrl();//更改路由地址栏信息
        this.getkejianfl(); //获取课件分类
        // chapterslists({
        //   md5key: localStorage.getItem("md5key"),
        //   kejianbooks_id: this.tbzyChosed.bookid,
        //   pid: pid,
        // }).then((res) => {
        //   this.mululist3 = res.retRes;
        //   console.log(res, "书本二级目录");
        //   let num = res.retRes.length
        //   this.tbzyChosed.mulu1.style.height = (this.mululist1.length+this.mululist2.length+num+1)*44 + 'px'
        //   this.tbzyChosed.mulu2.style.height = (this.mululist2.length+num+1)*44 + 'px'
        //   this.tbzyChosed.mulu3.style.height = (num+1) * 44 + 'px'
        // });
      // }
    },
    //点击任何更改页面参数的信息，就改变网页地址
    changeUrl(){
      console.log(this.page_size)
      if(this.bigtapvalue == 1){
        this.$router.push({
          name:'ResourceTb',
          query:{
            from:'self',
            bigTap: this.bigTap, //顶部和左侧大分类id
            bookTitle: this.tbzyChosed.booktitle, //同步资源分类下的书本名
            bookId: this.tbzyChosed.bookid, //同步资源分类下的书本id
            mulu1title: this.tbzyChosed.mulu1title, //同步资源分类下的目录名称
            mulu1id: this.tbzyChosed.mulu1id, //同步资源分类下的目录id
            mulu2title: this.tbzyChosed.mulu2title, //同步资源分类下的目录名称
            mulu2id: this.tbzyChosed.mulu2id, //同步资源分类下的目录id
            mulu3title: this.tbzyChosed.mulu3title, //同步资源分类下的目录名称
            mulu3id: this.tbzyChosed.mulu3id, //同步资源分类下的目录id
            fenleiTitle: this.fenleiTitle, //分类名
            feleiDid: this.kejianfl_id, //分类id
            page: this.page, //分页
            pageSize: this.page_size, //每页数量
          }
        })
      }else if(this.bigtapvalue == 2){
        this.$router.push({
          name:'ResourceTb',
          query:{
            from:'self',
            bigTap: this.bigTap, //顶部和左侧大分类id
            sjFlTitle: this.sjFlTitle, //试卷类型名
            sjFlId: this.kejiantag_id, //试卷类型id
            sjNjTitle: this.sjNjTitle, //试卷选中年级名
            sjNjId: this.sjNjId, //试卷选中年级id
            sjDqTitle: this.sjDqTitle, //试卷选中地区名
            sjDqId: this.sjDqId, //试卷选中地区id
            sjNfTitle: this.sjNfTitle, //试卷选中年份名
            sjNfId: this.sjNfId, //试卷选中年份id
            page: this.page, //分页
            pageSize: this.page_size, //每页数量
          }
        })
      }else if (this.bigtapvalue == 3){
        this.$router.push({
          name:'ResourceTb',
          query:{
            from:'self',
            bigTap: this.bigTap, //顶部和左侧大分类id
            scFlTitle: this.scFlTitle, //素材类型名
            scFlId: this.kejiantag_id, //素材类型id
            scTimeTitle: this.scTimeTitle, //素材时间名
            scTimeId: this.scTimeId, //素材时间端
            page: this.page, //分页
            pageSize: this.page_size, //每页数量
          }
        })
      }else if (this.bigtapvalue == 4){
        this.$router.push({
          name:'ResourceTb',
          query:{
            from:'self',
            bigTap: this.bigTap, //顶部和左侧大分类id
            jxkFlTitle: this.jxkFlTitle, //教学课分类名
            jxkFlId: this.classof, //教学课分类id/素材时间名
            page: this.page, //分页
            pageSize: this.page_size, //每页数量
          }
        })
      }else if (this.bigtapvalue == 5){
        this.$router.push({
          name:'ResourceTb',
          query:{
            from:'self',
            bigTap: this.bigTap, //顶部和左侧大分类id
            zybFlTitle: this.zybFlTitle, //资源包分类单元名
            zybFlId: this.ziyuanbaochapters_id, //资源包分类单元名
            page: this.page, //分页
            pageSize: this.page_size, //每页数量
          }
        })
      }
    },
    //获取课件分类
    getkejianfl() {
      kejianfl({
        md5key: localStorage.getItem("md5key"),
        nianji_id: this.nianji_id,
        systypes_id: 1,
      }).then((res) => {
        if (res.retRes.length == 0) {
          this.kejianflList = [];
        } else {
          this.kejianflList = res.retRes;
          console.log(this.booksList,"shuben shuben ",this.kejianbooks_id)
          this.booksList.forEach(item=>{
            if(item.id == this.kejianbooks_id){
              this.booknjid = item.nianji_id
              if(this.booknjid == 11){
                const zxTaps = { id: 1000, systypes_id: 4, title: "专项" };
                this.kejianflList.unshift(zxTaps); //增加一个全部的分类，这个分类获取列表不需要传课件分类和课件标签分类
              }
            }
          })
          
          
          const allTaps = { id: 0, systypes_id: 1, title: "全部" };
          this.kejianflList.unshift(allTaps); //增加一个全部的分类，这个分类获取列表不需要传课件分类和课件标签分类
          
          // this.kejianfl_id = this.QueryMsg.feleiDid
          //   ? this.QueryMsg.feleiDid
          //   : res.retRes[0].id; //暂时课件分类id取第一个
          // this.fenleiTitle = this.QueryMsg.fenleiTitle
          //   ? this.QueryMsg.fenleiTitle
          //   : res.retRes[0].title; //分类第一用作面包屑默认筛选条件
        }
        console.log(res.retRes, "课件分类");
        this.getkejianlists(); //获取课件列表
      });
    },
    //获取试卷分类
    getshijaunfl() {
      kejianfl({
        md5key: localStorage.getItem("md5key"),
        nianji_id: this.dingzhiNj_id,
        systypes_id: 2,
      }).then((res) => {
        const shijuantap = res.retRes[0].id;
        list_kejiantag({
          md5key: localStorage.getItem("md5key"),
          kejianfl_id: shijuantap,
          kemu_id: this.kemu_id,
          nianji_id: this.dingzhiNj_id,
        }).then((res) => {
          console.log(res, "试卷分类");
          this.sjflList = res.retRes;
        });
      });
      //获取年级列表
      nianjilists().then((res) => {
        console.log(res, "年级列表");
        this.nianjilists = res.retRes;
      });
    },
    //获取地区，年份
    getdqnf() {
      list_systypes({
        type_str: "dq",
      }).then((res) => {
        this.diquLists = res.retRes;
      });
      list_systypes({
        type_str: "nian",
      }).then((res) => {
        this.nianfenLists = res.retRes;
      });
    },
    //获取课件列表
    getkejianlists() {
      // this.kejianLists = [];
      list_kejian({
        md5key: localStorage.getItem("md5key"),
        kemu_id: this.kemu_id,
        nianji_ids: this.bigtapvalue == 2?this.sjNjId:'', //年级id暂时因数据原因不传
        type_id: this.systypes_id,
        kejianfl_id: this.kejianfl_id, //暂时为第一个分类,点击课件分类后更改
        kejianversions_id: this.kejianversions_id, //版本id
        kejianbooks_id: this.bigtapvalue != 2 ? this.kejianbooks_id : "", //初始为当前,点击书本更改
        kejianchapters_id: this.bigtapvalue != 2 ? this.kejianchapters_id : "", //初始为当前,点击目录更改
        kejiantag_id:this.kejiantag_id,
        of: "time",
        days: this.scTimeId, //素材近期
        page: this.page, //页面默认1
        page_size: this.page_size, //默认20
        //试卷
        nian_ids: this.sjNfId,
        dq_ids: this.sjDqId,
      }).then((res) => {
        console.log(res, "课件列表");
        const data = res.retRes;
        this.kejianLists = data;
        if(data.length <= 0){
          this.nothingShow = true
        }else{
          this.nothingShow = false
        }
        this.counts = res.retCounts;
        // console.log(data.length, "123123121312312313");
      });
    },
    //获取素材分类
    getsucaifl() {
      kejianfl({
        md5key: localStorage.getItem("md5key"),
        nianji_id: this.dingzhiNj_id,
        systypes_id: 3,
      }).then((res) => {
        this.sucaitap = res.retRes[0].id;
        list_kejiantag({
          md5key: localStorage.getItem("md5key"),
          kejianfl_id: this.sucaitap,
          kemu_id: this.kemu_id,
          nianji_id: this.dingzhiNj_id,
        }).then((res) => {
          console.log(res, "素材分类");
          this.scflList = res.retRes;
          // this.scflList.unshift({id:0,title:'全部'})
        });
      });
    },
    //获取教学课
    getjxk() {
      // this.kejianLists = [];
      list_jyjxk({
        md5key: localStorage.getItem("md5key"),
        kemu_id: this.kemu_id,
        nianji_id: this.dingzhiNj_id,
        kejianversions_id: this.kejianversions_id,
        kejianbooks_id: this.kejianbooks_id,
        kejianchapters_id: this.kejianchapters_id,
        jyjxtags_id: 2,
        of: this.classof,
        page: this.page, //页面默认1
        page_size: this.page_size, //默认
      }).then((res) => {
        console.log(res, "教学课列表");
        const data = res.retRes;
        this.kejianLists = data;
        this.counts = res.retCounts;
        if(this.counts <= 0){
          this.nothingShow = true
        }else{
          this.nothingShow = false
        }
      });
    },
    //获取课件包列表
    getkejianbaolists() {
      // this.kejianLists = [];
      list_kejianbao({
        md5key: localStorage.getItem("md5key"),
        type_id: 1,
        kemu_id: this.kemu_id,
        nianji_ids: this.dingzhiNj_id,
        kejianversions_id: this.kejianversions_id, //版本id
        // kejianbooks_id: this.kejianbooks_id, //初始为当前,点击书本更改
        kejianchapters_id: this.ziyuanbaochapters_id, //初始为当前,点击目录更改
        page: this.page, //页面默认1
        page_size: this.page_size, //默认20
      }).then((res) => {
        console.log(res, "资源包列表");
        const data = res.retRes;
        this.kejianLists = data;
        this.counts = res.retCounts;
        if(this.counts <= 0){
          this.nothingShow = true
        }else{
          this.nothingShow = false
        }
      });
    },
    
    //选择教研课教学课分类下的分类标签
    chosejyjxTagfl(id, title) {
      this.page = 1;
      this.currentPage = 1;
      this.classof = id;
      this.jxkFlTitle = title;
      this.getjxk();
      this.changeUrl();//更改路由地址栏信息
    },
    //获取资源中心数据
    getzyall() {
      if (this.dingzhiNj_id != 11) {
        //获取进入页面上半部分的资源包和当前计划的高一高二相关数据
        zyzxinfo({
          md5key: localStorage.getItem("md5key"),
        }).then((res) => {
          if (res.retInt == 1) {
            console.log(res, "课件包数据信息汇总");
            const data = res.retRes;
            if (
              data.info_2.zy_lists.length > 0 &&
              data.info_3.zy_lists.length > 0
            ) {
              this.tbzyb.push(data.info_2.zy_lists[0]);
              this.tbzyb.push(data.info_3.zy_lists[0]);
            } else if (
              data.info_1.zy_lists.length > 0 &&
              data.info_2.zy_lists.length == 0 &&
              data.info_3.zy_lists.length > 0
            ) {
              this.tbzyb.push(data.info_1.zy_lists[0]);
              this.tbzyb.push(data.info_3.zy_lists[0]);
            } else if (
              data.info_1.zy_lists.length > 0 &&
              data.info_2.zy_lists.length > 0 &&
              data.info_3.zy_lists.length == 0
            ) {
              this.tbzyb.push(data.info_1.zy_lists[0]);
              this.tbzyb.push(data.info_2.zy_lists[0]);
            } else {
              this.tbzyb = [];
            }
          }
        });
      }
    },
    //前往修改学科版本
    gokemu() {
      if(this.login_status == 1){
        this.$router.push({
          name: "ChangeClass",
        });
      }else{

        // localStorage.setItem('tcbb',this.kejianversions_id)
        // this.reload()
      }
      
    },
    qhbb(e){
      if(this.kejianversions_id == e.id){
        this.visible = false
      }else{
        localStorage.setItem('tcbb',e.id)
        this.reload()
      }
    },
    //切换大菜单
    changeTap(tap) {
      // document.documentElement.scrollTop = 0;
      this.bigTap = tap;
      this.page = 1;
      this.currentPage = 1;
      this.scTimeId = "";
      console.log(tap);
      if (tap != 2) {
        this.sjNfId = "";
        this.sjNfTitle = '全部';
        this.sjDqId = '';
        this.sjDqTitle = "";
        //收起试卷地区、年份分类
      }
      this.kejiantag_id = "";
      if (tap == 1) {
        this.systypes_id = 1;
        this.bigtapvalue = 1;
        this.bigTitle = "同步资源";
        this.getkejianfl(); //获取课件分类
        this.changeUrl();//更改路由地址栏信息
      } else if (tap == 2) {
        this.systypes_id = 2;
        this.bigtapvalue = 2;
        this.nianji_id = "";
        this.kejianfl_id = 0;
        this.sjNjId = ''
        this.sjNjTitle = "全部"
        this.sjNfId = "";
        this.sjNfTitle = '全部';
        this.sjDqId = '';
        this.sjDqTitle = "";
        this.bigTitle = "试卷";
        this.getkejianlists();
        this.changeUrl();//更改路由地址栏信息
      } else if (tap == 3) {
        this.systypes_id = 3;
        this.bigtapvalue = 3;
        this.nianji_id = "";
        this.kejianfl_id = 0;
        this.bigTitle = "素材库";
        this.getkejianlists();
        this.changeUrl();//更改路由地址栏信息
      } else if (tap == 4) {
        this.bigtapvalue = 4;
        this.kejianfl_id = 0;
        this.bigTitle = "教学课";
        this.getjxk();
        this.changeUrl();//更改路由地址栏信息
      } else if (tap == 5) {
        this.bigtapvalue = 5;
        this.kejianfl_id = 0;
        this.bigTitle = "资源包";
        console.log(this.ziyuanbaochaptersLists);
        this.ziyuanbaochapters_id =
          this.ziyuanbaochaptersLists.length > 0
            ? this.ziyuanbaochaptersLists[0].dy_id
            : 0;
        this.zybFlTitle =
          this.ziyuanbaochaptersLists.length > 0
            ? this.ziyuanbaochaptersLists[0].kejianbooks_title +
              "·" +
              this.ziyuanbaochaptersLists[0].dy_title
            : 0;
        this.getkejianbaolists();
        this.changeUrl();//更改路由地址栏信息
      }
    },
    //展开试卷全部地区分类
    getalldq() {
      list_systypes({
        type_str: "dq",
      }).then((res) => {
        // console.log(res, "地区");
        this.diquLists = res.retRes;
        this.sjdqNum = res.retRes.length + 1;
        this.getalldqshow = false;
      });
    },
    //展开试卷全部年份分类
    getallnf() {
      list_systypes({
        type_str: "nian",
      }).then((res) => {
        // console.log(res, "年份");
        this.nianfenLists = res.retRes;
        this.sjnfNum = res.retRes.length + 1;
        this.getallnfshow = false;
      });
    },
    //收起试卷全部地区分类
    getsomedq() {
      this.sjdqNum = 8; //收起试卷地区分类
      this.getalldqshow = true;
    },
    //收起试卷全部年份分类
    getsomenf() {
      this.sjnfNum = 7; //收起试卷年份分类
      this.getallnfshow = true;
    },
    //tap栏的置顶效果
    handleScrollY() {
      // console.log(document.documentElement.scrollTop,"滚动条高度高度")
      const beikeTaps = document.getElementsByClassName("beikeTaps")[0]; //需要置顶的教师教研tap栏
      // const kejianTaps = document.getElementsByClassName("kejianTaps")[0]; //需要置顶的课件分类tap栏
      // const resFl = document.getElementsByClassName("resFl")[0]; //需要置顶的资源分类左侧栏
      // const kejianTop = document.getElementsByClassName("top")[0]; //需要置顶的资源分类左侧栏
      const dingzhi = document.getElementsByClassName("dingzhi")[0];
      const recommend = document.getElementsByClassName("recommend")[0];
      // console.log(secondTop.getBoundingClientRect().top)
      // console.log(
      //   document.getElementsByClassName("recommend")[0].getBoundingClientRect()
      //     .bottom
      // );
      // console.log(
      //   document.getElementsByClassName("dingzhi")[0].getBoundingClientRect().bottom
      // );
      const x = dingzhi.getBoundingClientRect().top;
      const y = recommend.getBoundingClientRect().bottom;

      // console.log(x, y,"15316531279189378")
      if (x <= -10 && y > 180) {
        beikeTaps.style.position = "fixed";
        // kejianTaps.style.position = "static";
        // resFl.style.position = "static";
        // kejianTop.style.position = "static"
      } else if (x > -10) {
        beikeTaps.style.position = "static";
        // kejianTaps.style.position = "static";
        // resFl.style.position = "static";
      } else if (y < 100) {
        beikeTaps.style.position = "static";
        // kejianTaps.style.position = "fixed";
        // // resFl.style.position = "fixed";
        // kejianTop.style.position = "fixed"
      }
    },
    //点击删除选中图书项
    delechosedbook() {
      if(this.tbzyChosed.mulu3){
        this.tbzyChosed.mulu3.style.height = 0 +'px'
      }
      if(this.tbzyChosed.mulu2){
        this.tbzyChosed.mulu2.style.height = 44 +'px'
      }
      this.tbzyChosed.mulu1.style.height = this.bookHeight +'px'
      this.kejianbooks_id = this.tbzyChosed.bookid = ''
      this.kejianchapters_id = ''
      this.tbzyChosed.booktitle = ''
      this.tbzyChosed.mulu1id = ''
      this.tbzyChosed.mulu1title = ''
      this.tbzyChosed.mulu2id = ''
      this.tbzyChosed.mulu2title = ''
      this.tbzyChosed.mulu3id = ''
      this.tbzyChosed.mulu3title = ''
      this.nianji_id = "";
      this.kejianbooks_id = "";
      this.kejianchapters_id = "";
      this.page = 1;
      this.currentPage = 1;
      this.getkejianfl();
      this.changeUrl();//更改路由地址栏信息
    },
    //点击删除第一个目录
    delechosedmulu1() {
      if(this.tbzyChosed.mulu3){
        this.tbzyChosed.mulu3.style.height = 44 +'px'
      }
      this.tbzyChosed.mulu2.style.height = this.muluHeight +'px'
      this.tbzyChosed.mulu1.style.height = (this.mululist1.length+1) * this.muluHeight +'px'
      this.kejianchapters_id = ''
      this.tbzyChosed.mulu1id = ''
      this.tbzyChosed.mulu1title = ''
      this.tbzyChosed.mulu2id = ''
      this.tbzyChosed.mulu2title = ''
      this.tbzyChosed.mulu3id = ''
      this.tbzyChosed.mulu3title = ''
      this.page = 1;
      this.currentPage = 1;
      this.getkejianfl();
      this.changeUrl();//更改路由地址栏信息
    },
    //点击删除第二个目录
    delechosedmulu2() {
      this.tbzyChosed.mulu1.style.height = (this.mululist1.length+this.mululist2.length+1) * this.muluHeight +'px'
      this.tbzyChosed.mulu2.style.height = (this.mululist2.length+1) * this.muluHeight +'px'
      this.tbzyChosed.mulu3.style.height = this.muluHeight +'px'
      this.kejianchapters_id = this.tbzyChosed.mulu1id
      this.tbzyChosed.mulu2id = ''
      this.tbzyChosed.mulu2title = ''
      this.tbzyChosed.mulu3id = ''
      this.tbzyChosed.mulu3title = ''
      this.page = 1;
      this.currentPage = 1;
      this.getkejianfl();
      this.changeUrl();//更改路由地址栏信息
    },
    //点击删除第三个目录
    delechosedmulu3() {
      this.tbzyChosed.mulu1.style.height = (this.mululist1.length+this.mululist2.length+this.mululist3+1) * this.muluHeight +'px'
      this.tbzyChosed.mulu2.style.height = (this.mululist2.length+this.mululist3+1) * this.muluHeight +'px'
      this.tbzyChosed.mulu3.style.height = (this.mululist3+1) * this.muluHeight +'px'
      this.kejianchapters_id = this.tbzyChosed.mulu2id
      this.tbzyChosed.mulu3id = ''
      this.tbzyChosed.mulu3title = ''
      this.page = 1;
      this.currentPage = 1;
      this.getkejianfl();
      this.changeUrl();//更改路由地址栏信息
    },
    //点击选中课件分类
    choseKejianfl(id, systypes_id, title) {
      console.log(id, systypes_id);
      this.fenleiTitle = title; //点击分类，更新面包屑筛选分类名
      this.page = 1;
      this.currentPage = 1;
      this.kejianfl_id = id;
      this.systypes_id = systypes_id;
      this.kejiantag_id = "";
      this.getkejianlists(); //获取课件列表
      this.changeUrl();//更改路由地址栏信息
    },
    //选择试卷分类
    chosedsjfl(id,title) {
      this.kejiantag_id = id;
      this.sjFlTitle = title;
      this.page = 1;
      this.currentPage = 1;
      this.getkejianlists();
      this.changeUrl();//更改路由地址栏信息
    },
    //选中试卷年级分类
    chosedsjnj(id,title) {
      this.sjNjId = id;
      this.sjNjTitle = title;
      this.page = 1;
      this.currentPage = 1;
      this.getkejianlists();
      this.changeUrl();//更改路由地址栏信息
    },
    //选中试卷地区分类
    chosedsjdq(id,title) {
      this.sjDqId = id;
      this.sjDqTitle = title;
      this.page = 1;
      this.currentPage = 1;
      this.getkejianlists();
      this.changeUrl();//更改路由地址栏信息
    },
    //选中试卷年份分类
    chosedsjnf(id,title) {
      this.sjNfId = id;
      this.sjNfTitle = title;
      this.page = 1;
      this.currentPage = 1;
      this.getkejianlists();
      this.changeUrl();//更改路由地址栏信息
    },
    //试卷分类中分别选中全部
    choseall(type) {
      if (type == "fl") {
        this.kejiantag_id = "";
        this.sjFlTitle = "全部"
        this.getkejianlists();
        this.changeUrl();//更改路由地址栏信息
      } else if (type == "nianji") {
        this.sjNjId = "";
        this.sjNjTitle = "全部"
        this.getkejianlists();
        this.changeUrl();//更改路由地址栏信息
      } else if (type == "diqu") {
        this.sjDqId = "";
        this.sjDqTitle = "";
        this.getkejianlists();
        this.changeUrl();//更改路由地址栏信息
      } else if (type == "nianfen") {
        this.sjNfId = "";
        this.sjNfTitle = "全部"
        this.getkejianlists();
        this.changeUrl();//更改路由地址栏信息
      }
    },
    //选择sucai分类
    chosedscfl(id,title) {
      this.scFlId = this.kejiantag_id = id;
      this.scFlTitle = title;
      this.page = 1;
      this.currentPage = 1;
      this.getkejianlists();
      this.changeUrl();//更改路由地址栏信息
    },
    //选择素材下的时间分类标签
    chosesucaiTagfl(id,title) {
      this.page = 1;
      this.currentPage = 1;
      this.scTimeTitle = title;
      this.scTimeId = id;
      this.getkejianlists();
      this.changeUrl();//更改路由地址栏信息
    },
    //选择资源包分类
    chosedzybfl(id, book, title) {
      this.zybFlTitle = book + "·" + title;
      this.ziyuanbaochapters_id = id;
      this.page = 1;
      this.currentPage = 1;
      this.getkejianbaolists();
      this.changeUrl();//更改路由地址栏信息
    },
    //分页
    //调整每页条数
    handleSizeChange(val) {
      console.log("每页条数调整为", val,this.bigtapvalue);
      this.page_size = val;
      this.page = 1;
      this.currentPage = 1;
      this.changeUrl();//更改路由地址栏信息
      if (this.bigtapvalue == 4) {
        // this.changeUrl();//更改路由地址栏信息
        this.getjxk(); //获取教学课
      } 
      else if (this.bigtapvalue == 5) {
        this.getkejianbaolists();
        // this.changeUrl();//更改路由地址栏信息
      } else {
        this.getkejianlists(); //获取课件列表
        // this.changeUrl();//更改路由地址栏信息
      }
    },
    //跳转第几页
    handleCurrentChange(val) {
      console.log("当前页为第", val);
      this.page = val;
      if (this.bigtapvalue == 4) {
        this.getjxk(); //获取教学课
        this.changeUrl();//更改路由地址栏信息
      } else if (this.bigtapvalue == 5) {
        this.getkejianbaolists();
        this.changeUrl();//更改路由地址栏信息
      } else {
        this.getkejianlists(); //获取课件列表
        this.changeUrl();//更改路由地址栏信息
      }
    },
    //点击课件前往课件详情
    goresDetails(id, suffix) {
      const toResQuery = {
        id: id, //详情id
        gundongTop: document.documentElement.scrollTop, //保留同步页滚动高度
        path: this.$route.path, //同步资源页的页面路由地址
        routeName: "同步资源页", //同步资源页名称
        bigTapName: this.bigTitle, //顶部和左侧大分类名称
        bigTap: this.bigTap, //顶部和左侧大分类id
        page: this.page, //分页
        pageSize: this.page_size, //每页数量
      };
      if (this.bigtapvalue == 1) {
        let res = {
          //同步资源相关
          bookTitle: this.tbzyChosed.booktitle, //同步资源分类下的书本名
          bookId: this.tbzyChosed.bookid, //同步资源分类下的书本id
          mulu1title: this.tbzyChosed.mulu1title, //同步资源分类下的目录名称
          mulu1id: this.tbzyChosed.mulu1id, //同步资源分类下的目录id
          mulu2title: this.tbzyChosed.mulu2title, //同步资源分类下的目录名称
          mulu2id: this.tbzyChosed.mulu2id, //同步资源分类下的目录id
          mulu3title: this.tbzyChosed.mulu3title, //同步资源分类下的目录名称
          mulu3id: this.tbzyChosed.mulu3id, //同步资源分类下的目录id
          fenleiTitle: this.fenleiTitle, //分类名
          feleiDid: this.kejianfl_id, //分类id
        };
        if (suffix != "rar" && suffix != "zip") {
          let { href } = this.$router.resolve({
            path: "/resource/resDetails",
            query: { ...toResQuery, ...res },
          });
          window.open(href, "_blank");
        } else if (suffix == "rar" || suffix == "zip") {
          let { href } = this.$router.resolve({
            path: "/resource/zipResDetails",
            query: { ...toResQuery, ...res },
          });
          window.open(href, "_blank");
        }
      } else if (this.bigtapvalue == 2) {
        let res = {
          // 试卷相关
          sjFlTitle: this.sjFlTitle, //试卷类型名
          sjFlId: this.kejiantag_id, //试卷类型id
          sjNjTitle: this.sjNjTitle, //试卷选中年级名
          sjNjId: this.sjNjId, //试卷选中年级id
          sjDqTitle: this.sjDqTitle, //试卷选中地区名
          sjDqId: this.sjDqId, //试卷选中地区id
          sjNfTitle: this.sjNfTitle, //试卷选中年份名
          sjNfId: this.sjNfId, //试卷选中年份id
        };
        if (suffix != "rar" && suffix != "zip") {
          let { href } = this.$router.resolve({
            path: "/resource/resDetails",
            query: { ...toResQuery, ...res },
          });
          window.open(href, "_blank");
        } else if (suffix == "rar" || suffix == "zip") {
          let { href } = this.$router.resolve({
            path: "/resource/zipResDetails",
            query: { ...toResQuery, ...res },
          });
          window.open(href, "_blank");
        }
      } else if (this.bigtapvalue == 3) {
        let res = {
          //素材相关
          scFlTitle: this.scFlTitle, //素材类型名
          scFlId: this.kejiantag_id, //素材类型id
          scTimeTitle: this.scTimeTitle, //素材时间名
          scTimeId: this.scTimeId, //素材时间端
        };
        if (suffix != "rar" && suffix != "zip") {
          let { href } = this.$router.resolve({
            path: "/resource/resDetails",
            query: { ...toResQuery, ...res },
          });
          window.open(href, "_blank");
        } else if (suffix == "rar" || suffix == "zip") {
          let { href } = this.$router.resolve({
            path: "/resource/zipResDetails",
            query: { ...toResQuery, ...res },
          });
          window.open(href, "_blank");
        }
      }
    },
    //前往校验课内容
    goJiaoyanclass(jyjxk_id) {
      let { href } = this.$router.resolve({
        name: "JiaoyanClass",
        query: {
          id: jyjxk_id,
          path: this.$route.path,
          routeName: "同步资源页",
          bigTapName: this.bigTitle,
          bigTap: this.bigTap, //顶部和左侧大分类id
          jxkFlTitle: this.jxkFlTitle, //教学课分类名
          jxkFlId: this.classof, //教学课分类id
          page: this.page, //分页
          pageSize: this.page_size, //每页数量
        },
      });
      window.open(href, "_blank");
    },
    //前往备课资源包
    gobeikeziyuan(id) {
      let toResQuery = {
        id: id, //详情id
        gundongTop: document.documentElement.scrollTop, //保留同步页滚动高度
        path: this.$route.path, //同步资源页的页面路由地址
        routeName: "同步资源页", //同步资源页名称
        bigTapName: this.bigTitle, //顶部和左侧大分类名称
        bigTap: this.bigTap, //顶部和左侧大分类id
        zybFlTitle: this.zybFlTitle, //资源包分类单元名
        zybFlId: this.ziyuanbaochapters_id, //资源包分类单元名
        page: this.page, //分页
        pageSize: this.page_size, //每页数量
      };
      let { href } = this.$router.resolve({
        path: "/resource/beikeziyuan",
        query: toResQuery,
      });
      window.open(href, "_blank");
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollY, true);
  },
};
</script>
<style>
/* 弹窗相关 */
.el-message-box__headerbtn .el-message-box__close {
  display: none;
}
.el-button--primary {
  background-color: #1E60EB !important;
  border-color: #1E60EB !important;
}
/* .el-button--primary:hover {
  background-color: #1E60EB;
} */
/* 用于推荐是否有用按钮 */
.el-radio__input.is-checked .el-radio__inner {
  border-color: #1E60EB;
  background: #1E60EB;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #1E60EB;
}
.el-radio__inner:hover {
  border-color: #1E60EB !important;
}
/* 用于资源库书本选中 */
.el-tree-node__content {
  margin: 0;
  position: relative;
  height: 44px;
  color: #333;
}
.el-tree-node__label {
  margin-left: 40px;
  font-weight: 400;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.el-tree-node:focus > .el-tree-node__content {
  color: #1E60EB;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #1E60EB;
}
/* .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content */
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #E6ECFA;
}
.el-tree__empty-block {
  height: 0 !important;
  display: none;
}
.el-tree-node__expand-icon {
  position: absolute;
  right: 15px;
  font-size: 20px;
  /* color: #1E60EB; */
}
.el-tree-node__expand-icon.expanded {
  transform: rotate(180deg);
  color: #1E60EB;
}
.el-collapse-item__wrap {
  transition: 0.3s;
  border: 0;
}
.el-collapse-item__content {
  margin-top: 6px;
  padding-bottom: 0;
  height: auto !important;
}
/* .el-collapse-item__arrow {
  display: none !important;
} */
.el-collapse-item {
  margin-bottom: 6px !important;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #ccc;
}
.el-collapse {
  border-top: 0;
}

/* 用于分页 */
.el-select-dropdown__item.selected {
  color: #1E60EB !important;
}
.el-pagination__editor.el-input .el-input__inner {
  border-color: #ccc;
}
.page1 {
  width: 720px;
  margin: 0 auto;
}
.el-pagination {
  text-align: center;
  margin: 20px 80px 20px 0;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #1E60EB !important;
}
.el-pagination .el-select .el-input .el-input__inner:hover {
  border-color: #1E60EB !important;
}
.el-select .el-input__inner:focus {
  border-color: #1E60EB !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1E60EB !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff;
}
.el-pager li:hover {
  color: #1E60EB !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff !important;
}
</style>
<style lang="less" scoped>
#container {
  input::-webkit-input-placeholder {
    /* WebKit browsers*/
    color: green;
    background-color: #f9f7f7;
    font-size: 14px;
  }
  input:-moz-input-placeholder {
    /* Mozilla Firefox 4 to 18*/
    color: green;
    background-color: #f9f7f7;
    font-size: 14px;
  }
  input::-moz-input-placeholder {
    /* Mozilla Firefox 19+*/
    color: green;
    background-color: #f9f7f7;
    font-size: 14px;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10+*/
    color: green;
    background-color: #f9f7f7;
    font-size: 14px;
  }
  .el-input__inner {
    border: 1px solid #dcdfe6 !important;
  }
  width: 100%;

  .bigTap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px auto;
    margin-top: 20px;
    width: 1200px;
    background: #ffffff;
    border-radius: 10px;
    .banben {
      margin: 15px;
      h4 {
        margin-bottom: 8px;
        font-size: 18px;
        color: #333;
      }
      p {
        font-size: 14px;
        color: #333;
        span {
          color: #1E60EB;
          cursor: pointer;
        }
      }
      .choseBanben{
        color: red;
        p{
          color: red;
        }
      }
    }
    .tap{
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
    .tabs {
      margin-left: 30px;
      text-align: center;
      line-height: 48px;
      width: 200px;
      height: 48px;
      background: #f0f2f5;
      border-radius: 10px;
      font-size: 16px;
      color: #333;
      font-weight: 600;
      cursor: pointer;
    }
    .chosebigTap {
      background: #E6ECFA;
      color: #1E60EB;
    }
  }
  .content {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 20px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    .resFl {
      margin-right: 20px;
      width: 360px;
      min-height: 1000px;
      border-radius: 10px;
      background-color: #fff;
      // /deep/.el-icon-arrow-right:before {
      //   content: "" !important;
      // }
      h2 {
        padding-left: 20px;
        color: #333333;
        border-bottom: 1px solid #dee0e3;
        border-radius: 10px 10px 0px 0px;
        line-height: 48px;
        font-size: 18px;
      }
      .chosedTap {
        display: flex;
        justify-content: center;
        border-bottom: 1px solid #dee0e3;
        span {
          margin-left: 21px;
          margin-top: 17px;
          width: 80px;
          font-size: 12px;
          color: #333;
        }
        .chosedtabsLists {
          display: flex;
          flex-wrap: wrap;
          margin-top: 9px;
          width: 370px;
          .chosedtab {
            display: flex;

            align-items: center;
            margin-left: 10px;
            margin-bottom: 10px;
            padding-left: 14px;
            padding-right: 8px;
            height: 36px;
            background: #1E60EB;
            border-radius: 4px;
            font-size: 12px;
            color: #fff;
            i {
              position: relative;
              top: 1px;
              left: 2px;
              color: #fff !important;
            }
            /deep/.el-icon-close:before {
              color: #fff;
            }
          }
        }
      }
      .box {
        margin-top: 15px;
        border-radius: 10px;
        cursor: pointer;
        // border: 1px solid #dee0e3;
        border-radius: 0px 0px 10px 10px;
        min-height: 800px;
        border-top: 0;
        .chose {
          background-color: #E6ECFA !important;
          color: #1E60EB;
        }
        .el-icon-arrow-up:before {
          color: #1E60EB;
        }
        /deep/.el-collapse-item__arrow {
          display: none !important;
        }
        /deep/.el-collapse-item__header {
          display: block;
          border: 0;
          height: 48px;
        }
        /deep/.el-collapse {
          border: 0;
        }
        /deep/.el-tree {
          margin: 0 auto;
          width: 320px;
          border-radius: 10px;
          .el-tree-node__label {
            // font-weight: 600;
            font-size: 12px;
          }
          .el-tree-node.is-expanded > .el-tree-node__children {
            // background-color: red;
            .el-tree-node__label {
              font-weight: 400;
            }
          }
          .el-tree--highlight-current
            .el-tree-node.is-current
            > .el-tree-node__content {
            background: red;
            i {
              color: #1E60EB;
            }
          }
        }
        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 360px;
          height: 48px;
          background: #f5f7fa;
          h3 {
            margin-left: 20px;
            font-size: 16px;
          }
          i {
            margin-right: 40px;
            font-size: 14px;
            color: #999999;
          }
        }
        // .tongbu {
        //   .title {
        //     position: relative;
        //     top: 2px;
        //     width: 320px;
        //     border-radius: 10px;
        //     i {
        //       margin-right: 20px;
        //     }
        //   }
        //   .chosetoubuTitle {
        //     background-color: #E6ECFA !important;
        //     color: #1E60EB;
        //   }
        //   /deep/.el-collapse {
        //     margin: 0 auto;
        //     width: 320px;
        //     border-radius: 10px;
        //     overflow: hidden;
        //   }
        //   /deep/.el-collapse-item__wrap {
        //     background-color: #f5f7fa;
        //   }
        //   /deep/.el-tree {
        //     background-color: #f5f7fa;
        //   }
        // }
        .tongbu{
          .bookBox{
            transition:all .3s;
            // background-color: #1E60EB;
            margin: 0 auto ;
            margin-bottom: 10px;
            width: 320px;
            height: 48px;
            overflow: hidden;
            border-radius: 10px;
            background: #F5F7FA;
            .bookTitle{
            border-radius: 10px;
              display: flex;
              justify-content: space-between;
              width: 320px;
              height: 48px;
              line-height: 48px;
              font-size: 14px;
              font-weight: 600;
              p{
                margin-left: 20px;
              }
              span{
                margin-right: 20px;
              }
              
            }
            .bookchose{
              background: #E6ECFA;
              p{
                color: #1E60EB;
              }
            }
            .mulu1Box{
              transition: all .3s;
              height: 44px;
              overflow: hidden;
              .mulu1Title{
                display: flex;
                justify-content: space-between;
                width: 320px;
                height: 44px;
                line-height: 44px;
                font-size: 14px;
                p{
                  margin-left: 40px;
                }
                span{
                  margin-right: 20px;
                  i{
                        font-size: 14px;
                      }
                }
              }
              .muluchose{
                background: #E6ECFA;
                p{
                  color: #1E60EB;
                }
              }
              .mulu2Box{
                height: 44px;
                transition: all .3s;
                overflow: hidden;
                .mulu2Title{
                  display: flex;
                  justify-content: space-between;
                  width: 320px;
                  height: 44px;
                  line-height: 44px;
                  font-size: 14px;
                  p{
                    margin-left: 60px;
                  }
                    span{
                      margin-right: 20px;
                      i{
                        font-size: 14px;
                      }
                    }
                }
                .muluchose{
                  background: #E6ECFA;
                  p{
                    color: #1E60EB;
                  }
                }
                .mulu3Box{
                  height: 44px;
                  transition: all .3s;
                  overflow: hidden;
                  .mulu3Title{
                    display: flex;
                    justify-content: space-between;
                    width: 320px;
                    height: 44px;
                    line-height: 44px;
                    font-size: 12px;
                    p{
                      margin-left: 80px;
                    }
                    span{
                      margin-right: 20px;
                      i{
                        font-size: 14px;
                      }
                    }
                  }
                  .muluchose{
                    background: #E6ECFA;
                    p{
                      color: #1E60EB;
                    }
                  }
                }
              }
            }
          }
        }
        .books_chose {
          background: #E6ECFA;
          color: #1E60EB;
          i {
            color: #1E60EB;
          }
        }
        //试卷分类
        .sjflLists {
          margin: 0 auto;
          width: 320px;
          .shijuanfl {
            margin-bottom: 10px;
            width: 320px;
            height: 40px;
            background: #f5f7fa;
            border-radius: 10px;
            h3 {
              margin-left: 20px;
              font-size: 12px;
              font-weight: normal;
              line-height: 40px;
            }
          }
          .chosesjfl {
            background: #E6ECFA;
            h3 {
              color: #1E60EB;
            }
          }
        }
        //素材分类
        .scflLists {
          margin: 0 auto;
          width: 320px;
          .sucaifl {
            margin-bottom: 10px;
            width: 320px;
            height: 40px;
            background: #f5f7fa;
            border-radius: 10px;
            h3 {
              margin-left: 20px;
              font-size: 12px;
              line-height: 40px;
            }
          }
          .chosescfl {
            background: #E6ECFA;
            h3 {
              color: #1E60EB;
            }
          }
        }
        //资源包分类
        .ziyuanbaoflLists {
          margin: 0 auto;
          width: 320px;
          .ziyuanbaofl {
            margin-bottom: 10px;
            width: 320px;
            height: 40px;
            background: #f5f7fa;
            border-radius: 10px;
            h3 {
              margin-left: 20px;
              font-size: 12px;
              line-height: 40px;
            }
          }
          .chosescfl {
            background: #E6ECFA;
            h3 {
              color: #1E60EB;
            }
          }
        }
      }
    }
    .right {
      width: 820px;
      background-color: #fff;
      border-radius: 10px;
      // 课件顶部资源包
      .topziyuanbao {
        display: flex;
        margin-bottom: 5px;
        cursor: pointer;
        .topzybLists {
          display: flex;
          // align-items: center;
          margin-left: 20px;
          margin-top: 20px;
          width: 380px;
          height: 100px;
          background: #f5f7fa;
          border-radius: 10px;
          .pic {
            margin: 20px;
            width: 60px;
            height: 60px;
            img {
              width: 60px;
            }
          }
          .msg {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-top: 17px;
            .title {
              font-size: 14px;
              color: #333;
              font-weight: 600;
              width: 252px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2; // 控制多行的行数
              -webkit-box-orient: vertical;
            }
            .bottom {
              display: flex;
              margin-bottom: 17px;
              color: #939599;
              .upTime {
                display: inline-block;
                margin-right: 40px;
              }
              .zynum {
                a {
                  color: #f6444e;
                }
              }
            }
          }
        }
      }
      //课件分类
      .kejianTaps {
        display: flex;
        align-items: center;
        margin: 20px;
        margin-bottom: 10px;
        width: 780px;
        height: 68px;
        background: #f5f7fa;
        border-radius: 10px;
        .flname {
          width: 800px;
          user-select: none;
          span {
            display: inline-block;
            padding: 5px 15px;
            margin-right: 10px;
            font-size: 14px;
            color: #333;
            cursor: pointer;
            user-select: none;
          }
          .fenlei_color {
            color: #1E60EB;
            background: #E6ECFA;
          }
        }
        // .flname:first-of-type {
        //   span {
        //     padding-left: 20px;
        //   }
        // }
        // .flname:last-of-type {
        //   span {
        //     border-right: 0;
        //   }
        // }
      }
      // 试卷顶部分类
      .topshijuanfl {
        margin: 20px auto;
        width: 780px;
        background: #f5f7fa;
        border-radius: 10px;
        font-size: 14px;
        color: #333;
        overflow: hidden;
        .chosedsjfl {
          color: #1E60EB;
          background: #E6ECFA;
        }
        .topfl {
          display: flex;
          margin: 10px 20px;
          line-height: 20px;
          // height: 38px;
          // overflow: hidden;

          .fltitle {
            width: 48px;
            line-height: 30px;
          }
          .fllists {
            width: 650px;

            span {
              // margin-bottom: 10px;
              padding: 5px 10px;
              // text-align: center;
              line-height: 20px;
              // width: 68px;
              display: inline-block;
              margin-left: 15px;
              cursor: pointer;
            }
            // .flall {
            //   // background-color: #E6ECFA;
            //   // color: #1E60EB;
            // }
          }
        }
      }
      //素材分类
      .sucaiTaps {
        margin: 20px auto;
        width: 780px;
        background: #f5f7fa;
        border-radius: 10px;
        font-size: 14px;
        color: #333;
        overflow: hidden;
        .chosedsjfl {
          color: #1E60EB;
          background: #E6ECFA;
        }
        .topfl {
          display: flex;
          margin: 10px 20px;
          line-height: 20px;
          .fltitle {
            width: 48px;
            line-height: 30px;
          }
          .fllists {
            width: 650px;

            span {
              padding: 5px 10px;
              line-height: 20px;
              display: inline-block;
              margin-left: 15px;
              cursor: pointer;
            }
            .chosedfl {
              color: #1E60EB;
              background: #E6ECFA;
            }
          }
        }
      }
      //试卷分类
      .jiaoxueclass {
        display: flex;
        align-items: center;
        margin: 20px;
        margin-bottom: 10px;
        width: 780px;
        height: 68px;
        background: #f5f7fa;
        border-radius: 10px;
        .taps {
          width: 800px;
          span {
            display: inline-block;
            padding: 5px 15px;
            margin-right: 10px;
            font-size: 14px;
            color: #333;
            cursor: pointer;
            user-select: none;
          }
          .chosedfl {
            color: #1E60EB;
            background: #E6ECFA;
          }
        }
      }
      //课件类资源样式
      .kejianlist {
        width: 820px;
        // height: 800px;
        -ms-overflow-style: none; /* IE 10+ */
        scrollbar-width: none; /* Firefox */
        overflow-y: scroll;
        .kejianBox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          // margin-top: 30px;
          // padding-bottom: 30px;
          border-bottom: 1px dashed #e6e6e6;
          cursor: pointer;
          .kejianfile {
            margin-left: 40px;
            text-align: center;
            padding-top: 30px;
            padding-bottom: 30px;
            // width: 140px;
            // height: 140px;
            // background: linear-gradient(0deg, #e6e6e6, #ffffff);
            // border: 1px solid #ededed;
            img {
              width: 60px;
              height: 68px;
              vertical-align: text-bottom;
            }
          }
          .msg {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-top: 30px;
            padding-bottom: 30px;
            margin-left: 40px;
            min-height: 68px;
            // border-right: 1px solid #e6e6e6;
            cursor: pointer;
            .title {
              width: 460px;
              font-size: 16px;
              font-weight: 900;
              color: #333;
              overflow: hidden;
              white-space: wrap;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3; /*想省略几行就写几*/
              -webkit-box-orient: vertical;
              img{
                position: relative;
                top: 5px;
                margin-right: 8px;
                width: 36px;
              }
              span {
                display: inline-block;
                margin-right: 4px;
                text-align: center;
                color: #FFF;
                line-height: 20px;
                font-size: 12px;
                width: 40px;
                height: 20px;
                border-radius: 4px;
                background: #E63F3F;
              }
            }
            p {
              width: 480px;
              // min-height: 80px;
              line-height: 20px;
              font-size: 13px;
              color: #666;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
            }
            .bottom {
              display: flex;
              align-items: center;
              // position: relative;
              // top: 80px;
              margin-top: 4px;
              font-size: 12px;
              color: #999;
              .upTime {
                margin-left: 38px;
              }
              .seeNum {
                i {
                  margin-right: 5px;
                }
              }
              .rate {
                display: flex;
                margin-right: 38px;
                width: 148px;
              }
              /deep/.el-rate__icon {
                margin-right: 0;
              }
              .gzs{
                  display: flex;
                  align-items: center;
                  margin-right: 20px;
                  img{
                    position: relative;
                    right: -4px;
                      width: 16px;
                      height: 16px;
                  }
                  .gzsTitle{
                      display: inline-block;
                      padding: 2px 6px;
                      height: 16px;
                      background: #E6ECFA;
                      border-radius: 2px;
                      color: #1E60EB;
                  }
              }
            }
          }
          .fenge{
            width: 1px;
            height: 80px;
            background: #e6e6e6;
          }
          .kejianright{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 40px;
            .downLoad {
              margin-bottom: 12px;
              width: 96px;
              height: 28px;
              color: #fff;
              text-align: center;
              line-height: 28px;
              background: #1E60EB;
              border-radius: 14px;
              background: #1E60EB;
              border-radius: 14px;
              cursor: pointer;
            }
            .soucang{
              display: flex;
              align-items: center;
              color: #666;
              img{
                // position: relative;
                // top: 2px;
                margin-right: 6px;
                width: 12px;
              }
            }
            .money{
                display: flex;
                align-items: center;
                margin-top: 10px;
                color: #E63F3F;
                h6{
                  padding: 0 6px;
                  font-weight: normal;
                  color: #259d28;
                  font-size: 12px;
                }
                span{
                    display: inline-block;
                    // width: 32px;
                    padding: 0 6px;
                    margin-left: 4px;
                    height: 16px;
                    background: #FDE8E8;
                    border-radius: 2px;
                    text-align: center;
                    line-height: 16px;
                    font-size: 12px;
                }
            }
          }
          .jiaoyan {
            display: flex;
            // justify-content: space-between;
            flex-wrap: wrap;
            // padding: 30px 0 10px 0;
            width: 1200px;
            .box {
              position: relative;
              margin-left: 20px;
              margin-bottom: 30px;
              background-color: #fff;
              border-radius: 10px;
              cursor: pointer;
              img {
                margin-bottom: 10px;
                width: 240px;
                height: 136px;
                border-radius: 10px;
              }
              .activename {
                margin-bottom: 18px;
                width: 240px;
                font-size: 14px;
                color: #333333;
              }
              p {
                position: absolute;
                bottom: -5px;
                font-size: 12px;
                color: #939599;
              }
            }
            .box:hover {
              // transition: 1s;
              img {
                transition: 0.5s;
                // position: relative;
                // top: -10px;
                transform: translateY(-10px);
                box-shadow: 0px 2px 10px 2px #dedede;
              }
              .activename {
                color: #1E60EB;
              }
            }
          }
        }
        .ziyuanbaoLists {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 820px;
          // background: #f5f7fa;
          // border-radius: 10px;
          border-bottom: 1px dashed #e6e6e6;
          .pic {
            margin: 40px;
            width: 60px;
            img {
              width: 60px;
            }
          }
          .msg {
            position: relative;
            // margin-top: 16px;
            height: 80px;
            border-right: 1px solid #e6e6e6;
            cursor: pointer;
            .kejiantitle {
              font-size: 14px;
              color: #333;
              width: 490px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2; // 控制多行的行数
              -webkit-box-orient: vertical;
              p {
                width: 450px;
              }
            }
            .ziyuanbaodetails {
              margin-top: 5px;
              margin-bottom: 14px;
              span {
                color: #626366;
                font-size: 12px;
                a {
                  color: #f6444e;
                }
              }
              .leixing {
                display: inline-block;
                margin: 0 6px;
                width: 40px;
                height: 18px;
                background: #e6edfa;
                border-radius: 2px;
                text-align: center;
                line-height: 18px;
                color: #216efa;
              }
            }
            .bottom {
              // position: absolute;
              // bottom: 5px;
              color: #939599;
              .upTime {
                margin-right: 29px;
              }
              .seeNum {
                margin-right: 30px;
                i {
                  margin-right: 5px;
                }
              }
            }
          }
          .downLoad {
            margin: 0 40px;
            width: 96px;
            height: 28px;
            color: #fff;
            font-size: 12px;
            text-align: center;
            line-height: 28px;
            background: #1E60EB;
            border-radius: 14px;
            background: #1E60EB;
            border-radius: 14px;
            cursor: pointer;
          }
          .money{
              color: #11AAF9;
              img{
                position: relative;
                top: 0px;
                margin-right: 6px;
                width: 12px;
              }
            }
        }
        .ziyuanbaoLists:last-child {
          margin-bottom: 20px;
        }
        .ziyuanbaoLists:hover {
          .msg {
            .kejiantitle {
              color: #1E60EB;
            }
          }
        }
      }
      ::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      //课件列表鼠标移动的样式
      .kejianBox:hover {
        .msg {
          .title {
            color: #1E60EB;
          }
        }
      }
      //空数据的展示
      .nothing {
        width: 800px;
        height: 400px;
        text-align: center;
        p {
          font-size: 16px;
          color: #333;
          margin-top: 50px;
        }
        img {
          margin-top: 100px;
          width: 280px;
        }
      }

      //教研课
      .classBox {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 25px;
        .box {
          cursor: pointer;
          margin-bottom: 10px;
          background-color: #fff;
          border-radius: 10px;
          img {
            margin-bottom: 16px;
            width: 270px;
            height: 140px;
          }
          .activename {
            margin-bottom: 17px;
            width: 250px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            color: #333333;
          }
          p {
            font-size: 14px;
            color: #939599;
          }
        }
      }
    }
  }
  //首次弹出框的样式
  .kmchose {
    position: relative;
    margin-top: 80px;
    margin-left: 40px;
    cursor: pointer;
    p {
      margin: 20px 0;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #646566;
      color: #333;
    }
    .taps {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 40px;
      .classRadio {
        display: flex;
        margin-right: 60px;
        p{
          font-weight: normal;
          color: #333;
          font-size: 14px;
        }
        .tips {
          position: relative;
          top: 2px;
          margin-right: 8px;
          width: 14px;
          height: 14px;
          border: 1px solid #cccccc;
          border-radius: 100%;
          line-height: 12px;
          text-align: center;
          span {
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: 9px;
            height: 9px;
            background-color: #fff;
            border-radius: 100%;
          }
        }
        .tips2 {
          border: 1px solid #1E60EB;

          span {
            background-color: #1E60EB;
          }
        }
        p {
          margin: 0;
        }
      }
    }
    .tab2 {
      .classRadio {
        margin-bottom: 10px;
      }
    }
    .submitSet {
      margin: 0 auto;
      margin-top: 40px;
      // position: absolute;
      // right: 20px;
      // bottom: -80px;
      width: 120px;
      height: 40px;
      background: #1E60EB;
      color: #fff;
      border-radius: 6px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
  }
  /deep/.el-dialog--center {
    border-radius: 10px;
    // padding-bottom: 80px;
    background-image: url('../../assets/img/5.0/msgTc.png');
    background-size:100% ;
    background-repeat: no-repeat;
  }
  /deep/.el-dialog__header {
    padding: 0;
    
  }
}
</style>
